// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre:empty {
    display: none
}

.gutter,
.gutter-horizontal {
    display: none
}

.pabloo-theme {
    font-weight: 400;
    font-family: inter, sans-serif !important
}

.pabloo-hero-tagline {
    font-weight: 500;
    max-width: 844px;
    margin-left: auto !important;
    margin-right: auto !important
}

.sp-button {
    display: inline-flex !important;
    justify-content: center !important;
    align-items: center !important
}

.pabloo-global-header {
    padding: 0 !important
}

.pabloo-site-header {
    background: #fff;
    z-index: 999;
    width: 100%
}

.home-hero-image img {
    width: 1378px;
    max-width: 100%
}

.pabloo-header-container {
    max-width: 1300px;
    padding: 0 10px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    min-height: 80px
}

#pabloo-desktop-menu-links {
    padding-left: 45px;
    width: 100%;
    display: flex;
    justify-content: space-between
}

#pabloo-desktop-menu-links ul {
    list-style-type: none;
    display: flex;
    gap: 24px;
    align-items: center
}

#pabloo-desktop-menu-links li {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px
}

#pabloo-desktop-menu-links li a {
    color: #353535;
    text-decoration: none;
    font-family: inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px
}

#pabloo-desktop-menu-cta a {
    background: #16a34a;
    color: #fff !important;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 7px 24px;
    gap: 4px;
    border: 1px solid #16a34a;
    border-radius: 40px;
    font-weight: 700 !important;
    font-size: 16px;
    line-height: 24px
}

.pabloo-mobile-menu {
    display: none
}

.pabloo-mobile-menu-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 58px;
    padding: 0 24px
}

#pabloo-menu-close {
    display: none
}

#pabloo-mobile-menu-navigation {
    display: none
}

#pabloo-mobile-menu-cta-header {
    padding-top: 15px;
    margin-bottom: 16px;
    color: #fff;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    text-align: center
}

#pabloo-mobile-menu-cta a {
    background: #fe4715;
    color: #fff;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 6px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 11.3418px;
    line-height: 17px
}

#pabloo-mobile-menu-cta img {
    width: 250px;
    margin: auto;
    display: block
}

#pabloo-mobile-menu-links {
    background-color: #fff;
    padding: 24px
}

#pabloo-mobile-menu-links ul {
    list-style-type: none
}

#pabloo-mobile-menu-links li {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    padding-bottom: 24px
}

#pabloo-mobile-menu-links li a {
    color: #171717;
    text-decoration: none
}

#pabloo-desktop-menu-hover-help {
    position: absolute;
    z-index: 10;
    width: 610px;
    background: #fff;
    left: -254px;
    padding: 40px;
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #374151;
    top: 60px;
    display: none;
    box-shadow: 0 4px 4px #f7f2ea
}

.help-has-dropdown a {
    display: flex;
    align-items: center
}

.help-has-dropdown svg {
    margin-left: 10px;
    margin-right: 4px
}

#hover-top-arrow {
    position: absolute;
    top: -18px;
    left: 286px
}

#pabloo-desktop-menu-hover-help-1 {
    display: flex;
    flex-direction: column;
    width: 52%
}

#pabloo-desktop-menu-hover-help-1 a {
    margin-bottom: 16px;
    color: #374151
}

#pabloo-desktop-menu-hover-help-2 {
    border: 1px solid #e5e7eb
}

#pabloo-desktop-menu-hover-help-3 {
    display: flex;
    flex-direction: column;
    padding-left: 63px
}

#pabloo-desktop-menu-hover-help-3 span {
    display: block;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: .96px;
    text-transform: uppercase;
    color: #9ca3af;
    margin-bottom: 16px
}

#pabloo-desktop-menu-hover-help-3 a {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -.355556px;
    color: #334155;
    margin-bottom: 4px;
    display: flex;
    align-items: center
}

#pabloo-desktop-menu-hover-help-3 a svg {
    margin-left: 8px
}

#pabloo-desktop-menu-hover-help-3 p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: -.355556px;
    color: #374151
}

@media(max-width:950px) {
    .pabloo-mobile-menu {
        display: block
    }

    .pabloo-desktop-menu {
        display: none
    }

    .pabloo-site-branding {
        width: 150px
    }

    .sp-el-section.pabloo-site-header-wrapper,
    .pabloo-site-header-wrapper .sp-el-row,
    .pabloo-site-header-wrapper .sp-el-col,
    .pabloo-site-header-wrapper .sp-el-block {
        padding: 0 !important
    }

    .mobile-center {
        text-align: center;
    }
}

.pabloo-global-footer {
    padding: 0 !important
}

.pabloo-site-footer {
    background: #fff;
    z-index: 999;
    width: 100%
}

.home .pabloo-site-footer .sp-section-shape .pabloo-shape-fill {
    fill: #edf8fc
}

#footer-cta {
    background-color: #ffe7f2;
    width: 1368px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
    overflow: hidden;
    min-height: 300px
}

#footer-cta-content {
    display: flex;
    margin: 0 auto;
    justify-content: space-between
}

#footer-cta-1 {
    max-width: 570px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 44px
}

#footer-cta-1 .h1 {
    color: #171717;
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    font-family: 'ibm plex serif';
    margin-bottom: 36px
}

#footer-cta-1 p {
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 28px
}

#footer-cta-1 a {
    background: #16a34a;
    border-radius: 40px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #f9fafb;
    padding: 15px 54px;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    text-decoration: none !important;
    width: 289px
}

#footer-cta-2 {
    position: relative;
    display: flex
}

.footer-cta-screenshot {
    width: 729px;
    max-width: 100%;
    height: auto;
    align-self: flex-end
}

.footer-cta-arrow {
    position: absolute;
    right: -124px;
    top: 73px
}

.footer-cta-screenshot-mobile {
    display: none
}

#dup_integrations_action {
    padding-bottom: 26px
}

@media(max-width:1050px) {
    .footer-cta-arrow {
        display: none
    }

    #footer-cta-2 {
        margin-right: 0
    }

    #footer-cta-1 {
        max-width: 50%
    }
}

@media(max-width:640px) {
    #dup_integrations_action {
        display: none !important
    }

    .sp-el-section.pabloo-site-footer-wrapper,
    .pabloo-site-footer-wrapper .sp-el-row,
    .pabloo-site-footer-wrapper .sp-el-col,
    .pabloo-site-footer-wrapper .sp-el-block {
        padding: 0 !important
    }

    #footer-cta-content {
        display: block;
        padding: 0
    }

    #footer-cta-1 {
        max-width: 100%
    }

    #footer-cta {
        background-image: none;
        border-radius: 0
    }

    #footer-cta-1 .h1 {
        padding-top: 40px;
        margin-top: 0 !important
    }

    #footer-cta-1 {
        padding-left: 36px;
        padding-right: 36px;
        text-align: center
    }

    #footer-cta-1 a {
        margin-left: auto;
        margin-right: auto;
        margin-top: 24px
    }

    #footer-cta-1 .h1 {
        font-weight: 700;
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 8px;
        position: relative;
        z-index: 10
    }

    #footer-cta-1 p {
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 32px
    }

    .footer-cta-screenshot-mobile {
        display: block
    }

    .footer-cta-screenshot {
        display: none
    }

    .footer-cta-arrow {
        display: block;
        position: absolute;
        right: 10px;
        top: -363px;
        height: 77px;
        z-index: 0
    }
}

#footer-links-main {
    max-width: 1362px;
    padding: 20px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    padding-top: 89px
}

#footer-links-main-1 {
    width: 25%
}

#footer-links-main-2 {
    width: 27%
}

#footer-links-main-3 {
    width: 31%
}

#footer-links-main h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #171717;
    margin-bottom: 24px
}

#footer-social {
    display: flex;
    flex-direction: row;
    color: #334155;
    margin-top: 8px
}

#footer-social a {
    font-size: 17px !important;
    margin-right: 10px
}

#footer-links-main ul,
#footer-links-content ul,
#footer-links-brands ul,
#footer-sub ul {
    list-style-type: none
}

#footer-links-main li,
#footer-links-content li,
#footer-links-brands li {
    padding-bottom: 6px
}

#footer-links-main ul a,
#footer-links-content ul a,
#footer-links-brands ul a {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #171717
}

#footer-links-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1362px;
    padding: 20px;
    margin-left: auto;
    margin-right: auto
}

#footer-links-content-heading,
#footer-links-brands-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 1362px;
    padding: 20px;
    margin-left: auto;
    margin-right: auto;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    color: #171717;
    white-space: nowrap
}

#footer-links-content-heading {
    padding-top: 60px;
    padding-bottom: 0;
    justify-content: flex-start
}

#footer-links-content-heading span,
#footer-links-brands-heading span {
    margin-left: 40px;
    border-bottom: 1px solid #d1d5db;
    width: 100%
}

#footer-links-brands-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1362px;
    padding: 20px;
    padding-top: 40px;
    margin-left: auto;
    margin-right: auto
}

#footer-links-brands {
    display: flex;
    flex-direction: row;
    max-width: 1362px;
    padding: 20px;
    padding-bottom: 42px;
    margin-left: auto;
    margin-right: auto
}

#footer-links-brands-1 {
    padding-right: 385px
}

#footer-links-brands-2 {
    width: 24%
}

#footer-links-brands-1 div {
    display: flex;
    flex-direction: row;
    align-items: center;
    max-width: 390px;
    margin-bottom: 21px
}

#footer-links-brands h4 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #171717;
    text-align: left !important
}

#footer-links-brands-1 div img {
    margin-right: 32px
}

#footer-links-brands-1 p {
    max-width: 374px;
    color: #353535
}

#footer-sub-div {
    display: flex;
    max-width: 1362px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto
}

#footer-sub-div span {
    border-top: 1px solid #000;
    width: 100%
}

#footer-sub-wrapper {
    background: #f1f5f9
}

#footer-sub {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 1362px;
    padding: 32px 20px;
    margin-left: auto;
    margin-right: auto
}

#footer-sub p {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #334155;
    margin-bottom: 7px
}

#footer-sub ul {
    display: flex;
    flex-direction: row;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-decoration-line: underline
}

#footer-sub ul a {
    color: #334155 !important;
    font-weight: 500
}

#footer-sub ul li {
    padding-right: 16px
}

#footer-sub-2 img:first-child {
    max-width: 48px;
    margin-right: 12px
}

#footer-social-wrapper {
    display: none
}

@media(max-width:1000px) {
    #footer-links-brands-1 {
        padding-right: 20px
    }
}

@media(max-width:800px) {
    #footer-links-brands-1 p {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px
    }

    #footer-links-brands-1 div img {
        margin-right: 22px
    }

    #footer-links-main {
        display: block;
        padding: 48px 24px 0 !important
    }

    #footer-links-main ul a {
        font-size: 14px !important
    }

    #footer-links-main-1 ul li:last-child #footer-social a {
        margin-right: 10px;
        margin-top: 10px;
        font-size: 20px !important
    }

    #footer-links h3 {
        text-align: left !important
    }

    #footer-links-main>div {
        width: 100%
    }

    #footer-links-main-2 h3,
    #footer-links-main-3 h3,
    #footer-links-main-4 h3 {
        padding-top: 21px;
        padding-bottom: 21px;
        margin-bottom: 0
    }

    #footer-links-content-heading,
    #footer-links-brands-heading {
        font-size: 18px
    }

    #footer-links-content-heading span,
    #footer-links-brands-heading span {
        display: none
    }

    #footer-links-brands-1 {
        margin-bottom: 20px
    }

    #footer-sub {
        display: flex;
        flex-direction: column
    }

    #footer-links-content,
    #footer-links-brands {
        display: block
    }

    #footer-links-brands-2,
    #footer-links-brands-3 {
        width: 100%
    }

    #footer-sub ul {
        display: block
    }

    #footer-sub p {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 8px
    }

    #footer-sub-1 li {
        margin-bottom: 16px
    }

    #footer-sub-1 li:last-child {
        margin-bottom: 25px
    }

    #footer-links-brands {
        padding-bottom: 24px;
        padding-top: 0
    }

    #footer-links-brands-heading,
    #footer-links-content-heading {
        padding-top: 24px;
        padding-bottom: 24px
    }

    #footer-links-content {
        padding-top: 0;
        padding-bottom: 0
    }

    #footer-links-main li,
    #footer-links-content li,
    #footer-links-brands li {
        padding-bottom: 8px
    }

    #footer-links-main li:nth-child(6),
    #footer-links-content li:last-child,
    #footer-links-brands li:last-child {
        padding-bottom: 0
    }

    #footer-links-content-1 ul,
    #footer-links-content-2 ul,
    #footer-links-brands-1 ul,
    #footer-links-brands-2 ul {
        padding-bottom: 8px
    }

    #footer-links-main-1 h3,
    #footer-links-main-2 h3,
    #footer-links-main-3 h3,
    #footer-links-main-4 h3,
    #footer-links-content-heading,
    #footer-links-brands-heading {
        display: flex;
        justify-content: space-between;
        cursor: pointer
    }


    .ft-close-divider {
        border-bottom: 1px solid #d1d5db
    }

    .ft-close-divider {
        margin: 14px 24px
    }

    #footer-links-main-2 ul,
    #footer-links-main-3 ul,
    #footer-links-main-4 ul,
    #footer-links-content {
        display: none
    }

    #footer-social-wrapper {
        display: none;
        padding: 24px;
        padding-top: 12px
    }

    #footer-social-wrapper h3 {
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        color: #171717;
        margin-bottom: 18px
    }

    #footer-social-mobile a {
        color: #334155 !important;
        margin-right: 10px;
        font-size: 17px
    }

    .ft-close-divider-2 {
        border-bottom: 1px solid #334155;
        margin-bottom: -24px;
        padding-bottom: 12px
    }

    #footer-links-main-2 ul,
    #footer-links-main-3 ul,
    #footer-links-main-4 ul {
        padding-top: 8px;
        padding-bottom: 8px
    }

    #footer-links-brands-heading.ft-close {
        padding-bottom: 0
    }

    #footer-links-content {
        padding-bottom: 24px
    }

    #footerlinks-main-4 {
        border-bottom: 1px solid #334155
    }
}

.hero-header {
    font-family: 'ibm plex serif'
}

.pabloo-top-6-advantages {
    margin-top: -3px !important
}

.pabloo-hero-tagline {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px !important
}

.hero-main-image {
    margin-bottom: -520px !important
}

.pabloo-home-feature-grid {
    padding-top: 410px !important
}

.pabloo-home-feature-grid-2 {
    padding-top: 340px !important
}

.pabloo-top-6-advantages p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px
}

.home-template-section-title {
    font-family: 'ibm plex serif' !important;
    font-weight: 700 !important;
    font-size: 40px !important;
    line-height: 48px !important
}

.home-section1-header {
    font-family: 'ibm plex serif';
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;
    max-width: 800px;
    margin-left: auto !important;
    margin-right: auto !important
}

.home-what-people-are-saying-title,
.home-templates-title,
.home-faq-title,
.header-wordpress-tips-and-tricks {
    font-family: 'ibm plex serif';
    font-weight: 700;
    font-size: 40px;
    line-height: 48px
}

.home-section1-desc {
    font-weight: 400;
    max-width: 900px;
    margin-left: auto;
    margin-right: auto
}

.home-section1-feature img {
    align-self: flex-start
}

.home-section1-feature .sp-text-center {
    text-align: left
}

.home-section1-feature .sp-css-description {
    font-weight: 500
}

.home-section1-features pre {
    display: none
}

.home-section1-features {
    gap: 24px;
    margin-bottom: 32px !important
}

.home-section1-features h3 {
    font-weight: 700;
    font-size: 20px !important;
    line-height: 24px !important
}

.home-section1-features p {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px
}

.home-section1-features {
    margin-bottom: 0 !important
}

.home-section1-cta {
    margin-top: 10px !important
}

@media(max-width:640px) {

    .home-what-people-are-saying-title,
    .home-templates-title,
    .home-faq-title,
    .header-wordpress-tips-and-tricks {
        font-size: 22px !important;
        line-height: 30px !important
    }
}

.home-section-what-users-say .sp-section-shape .pabloo-shape-fill {
    fill: #faf7f1
}

.home-section1-see-all a {
    margin-left: 18px;
    text-decoration: none !important;
    padding-bottom: 3px;
    color: #171717;
    font-weight: 500;
    border-bottom: 1px solid #171717
}

.four-nine {
    font-weight: 500
}

.home-testimonials pre,
.home-testimonials .sp-el-col pre {
    display: none
}

.home-testimonials {
    gap: 24px
}

.home-testimonials .sp-testimonial-wrapper img {
    display: none
}

.home-testimonials p {
    margin-bottom: 30px;
    font-weight: 500
}

.home-testimonials .sp-el-col {
    min-height: 462px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
}

@media(max-width:640px) {
    .testimonial-grid .testimonial {
        box-shadow: none !important
    }

    .testimonial-grid .testimonial:nth-child(3),
    .testimonial-grid .testimonial:nth-child(4),
    .testimonial-grid .testimonial:nth-child(5),
    .testimonial-grid .testimonial:nth-child(6),
    .testimonial-grid .testimonial:nth-child(7),
    .testimonial-grid .testimonial:nth-child(8),
    .testimonial-grid .testimonial:nth-child(9),
    .testimonial-grid .testimonial:nth-child(10),
    .testimonial-grid .testimonial:nth-child(11),
    .testimonial-grid .testimonial:nth-child(12),
    .testimonial-grid .testimonial:nth-child(13),
    .testimonial-grid .testimonial:nth-child(14),
    .testimonial-grid .testimonial:nth-child(15),
    .testimonial-grid .testimonial:nth-child(16),
    .testimonial-grid .testimonial:nth-child(17) {
        display: none
    }
}

.home-section-top7 {
    font-weight: 400
}

.home-section-top7 h2 {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px
}

.home-section-top7 h3 {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px
}

.home-top-7-row {
    margin-bottom: 20px !important;
    gap: 40px
}

@media(max-width:640px) {
    .home-section-top7 h1 {
        font-size: 22px !important;
        line-height: 30px !important
    }
}

.home-faq-desc,
.home-tandt-desc {
    font-weight: 400
}

.home-faq-desc a {
    color: #374151 !important;
    text-decoration: none !important;
    border-bottom: 1px solid #374151
}

.faq__accordion .fa-angle-right,
.faq__accordion .fa-angle-down {
    line-height: 1 !important
}

.page-home-page .sp-posts-shortcode {
    position: relative
}

@media(max-width:640px) {
    .page-home-page .sp-posts-shortcode:after {
        display: none
    }
}


.global-design-header h1 {
    padding-top: 66px;
    padding-bottom: 3px;
    font-family: 'ibm plex serif', serif !important;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px
}

.global-design-header .sp-text-wrapper {
    font-weight: 400
}

@media(max-width:640px) {
    .global-design-header h1 {
        font-weight: 700 !important;
        font-size: 24px !important;
        line-height: 32px !important
    }

    .global-design-header .sp-text-wrapper {
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 24px !important
    }

    .global-design-header .sp-text-wrapper p {
        text-align: center !important
    }
}

.page-home-page .sp-posts-block-wrapper .sp-custom-grid {
    position: relative;
    z-index: 20
}

.global-cta {
    margin-left: auto;
    margin-right: auto
}

.global-cta-headline {
    font-weight: 900
}

.global-cta-text {
    font-weight: 500
}

.cta-headline {
    font-weight: 900
}

.cta-desc {
    font-weight: 500
}

#footer-cta .sp-section-shape {
    position: relative
}

.footer-links-1 {
    font-weight: 500
}

.footer-divider-header {
    white-space: nowrap
}

.footer-divider {
    width: 100%
}

.footer-terms-links a {
    text-decoration: none;
    font-weight: 500
}

.footer-am-branding h4 {
    margin-bottom: 0
}

.home #sp-kzokb6 .sp-section-top .pabloo-shape-fill {
    fill: #edf8fc
}

.home .pabloo-site-footer-wrapper #footer-cta,
.page-id-22068 .pabloo-site-footer-wrapper #footer-cta {
    position: relative;
    top: -150px;
    margin-bottom: -150px
}

.blog-cta-logged-in,
.blog-cta {
    position: relative
}

.blog-cta-form {
    position: absolute !important;
    bottom: 44px;
    left: 32px;
    width: 361px !important;
    margin: 0 !important
}

.blog-cta-form .wpforms-field {
    padding-bottom: 0 !important
}

.blog-cta-form .wpforms-field-medium {
    max-width: 100% !important
}

.blog-cta-form .wpforms-submit {
    max-width: 100% !important;
    background: #fe4715 !important;
    border-radius: 4px !important;
    padding: 12px 10px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #f9fafb !important;
    width: 100% !important;
    border: none !important
}

.blog-cta-logged-in p {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #374151;
    width: 364px;
    position: absolute;
    bottom: 171px;
    left: 32px
}

.blog-cta-logged-in a {
    background: #fe4715 !important;
    border-radius: 4px !important;
    padding: 12px 117px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #f9fafb !important;
    position: absolute;
    bottom: 89px;
    left: 32px;
    text-decoration: none !important
}

@media(max-width:640px) {

    .blog-cta-logged-in,
    .blog-cta {
        display: none
    }

    .wp-post-image {
        padding: 14px !important
    }
}

.blog-newsletter-sidebar input,
.blog-newsletter-sidebar button {
    max-width: 100% !important;
    width: 100% !important;
    box-shadow: none !important
}

.blog-newsletter-sidebar input::placeholder {
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #6b7280 !important
}

.blog-newsletter-sidebar .wpforms-submit {
    background: #fe4715 !important;
    color: #fff !important;
    border-radius: 4px !important;
    font-weight: 600 !important;
    font-size: 20px !important;
    line-height: 28px !important;
    padding: 12px 32px !important
}

.sidebar-newsletter .wpforms-container {
    margin: 0 auto !important
}

.pabloo-blog,
.pabloo-below-blog {
    gap: 20px
}

.pabloo-blog-main {
    width: 100% !important
}

.pabloo-blog-sidebar,
.pabloo-below-blog-sidebar {
    width: 413px !important
}

.sidebar-seach {
    padding: 24px !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important
}

.sidebar-seach .sp-searchform input::placeholder {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #6b7280 !important
}

.sidebar-seach form {
    width: 100% !important
}

.sidebar-seach input {
    height: 48px !important;
    border: 1px solid #e5e7eb !important;
    border-right: none !important;
    font-weight: 500 !important;
    font-size: 16px !important
}

.sidebar-seach button {
    height: 48px !important;
    border: 1px solid #e5e7eb !important;
    border-left: none !important
}

.sidebar-seach form>div {
    padding: 0 !important
}

.sidebar-popular {
    border-top: none !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important
}

.sidebar-popular h3 {
    margin-bottom: 30px !important
}

.sidebar-newsletter input {
    height: 48px !important;
    border: 1px solid #e5e7eb !important;
    font-weight: 500 !important;
    background: #f9fafb !important;
    color: #6b7280 !important;
    font-weight: 500 !important;
    font-size: 16px !important
}

.sidebar-newsletter .sp-html .mb-2 {
    margin-bottom: 16px !important
}

.sidebar-newsletter button {
    height: 52px !important;
    margin-top: 0 !important;
    font-size: 20px !important;
    font-weight: 600 !important
}

.sidebar-newsletter .sidebar-follow {
    display: inline-flex !important;
    width: 40% !important;
    height: 30px !important
}

.sidebar-newsletter .sidebar-follow-links {
    display: inline-flex !important;
    width: 60% !important
}

.pabloo-blog-main-posts .sp-posts-block-title {
    margin-top: 23px !important;
    font-family: 'ibm plex serif', sans-serif !important
}

.pabloo-blog-main-posts .sp-posts-text {
    font-weight: 400 !important
}

.pabloo-blog-main-posts .sp-posts-block-read-more {
    font-weight: 500 !important
}

.sp-posts-block-pagination .page-numbers {
    background: #f0f3f5;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
    margin-left: 4px;
    color: #374151
}

.sp-posts-block-pagination .page-numbers.current {
    background-color: #171717;
    color: #fff
}

.sp-posts-block-pagination .next.page-numbers {
    background: 0 0;
    white-space: nowrap;
    margin-left: 8px
}

.sp-posts-block-pagination .prev.page-numbers {
    background: 0 0;
    white-space: nowrap;
    margin-right: 16px
}

.sp-postcontent p:empty {
    display: none
}

@media(max-width:640px) {
    .sp-posts-single-block {
        margin-bottom: 0 !important;
        padding: 24px !important
    }

    .pabloo-blog-main-posts .sp-posts-block-title {
        margin: 0 !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        text-align: left !important
    }

    .sp-posts-block-excerpt,
    .sp-posts-block-read-more {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px
    }

    .pabloo-blog-sidebar .sp-el-row,
    .pabloo-blog-sidebar .sp-el-col,
    .pabloo-blog-sidebar .sp-el-section,
    .sidebar-blog-big-cta {
        padding: 0 !important
    }

    .sidebar-seach {
        display: none
    }

    .sidebar-popular,
    .sidebar-newsletter {
        border: none !important
    }

    .sidebar-popular-posts h3.sp-type-header {
        text-align: left !important;
        font-weight: 700 !important;
        font-size: 22px !important;
        line-height: 32px !important;
        margin-bottom: 10px !important
    }

    .sidebar-newsletter h3.sp-type-header {
        text-align: left !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        line-height: 28px !important;
        margin-bottom: 10px !important
    }

    .sidebar-blog-big-cta,
    .sidebar-popular-post {
        margin-bottom: 60px !important
    }

    h1.sp-type-posttitle,
    #b2xxuk.sp-type-posttitle {
        text-align: left !important
    }

    .sp-postcontent h2,
    .sp-postcontent h3,
    .sp-postcontent h4,
    .sp-postcontent h5,
    .sp-postcontent h6 {
        text-align: left !important
    }

    .sp-postcontent h2 {
        font-size: 18px !important;
        line-height: 28px !important
    }

    .sp-postcontent h3 {
        font-size: 16px !important;
        line-height: 24px !important
    }

    .sp-postcontent h4 {
        font-size: 15px !important;
        line-height: 23px !important
    }
}

.blog-comments .fn a {
    color: #334155 !important;
    font-size: 18px !important
}

.blog-comments .comment-metadata a {
    color: #374151 !important;
    font-weight: 500;
    font-size: 16px !important
}

.blog-comments .avatar {
    width: 64px !important;
    height: 64px !important;
    margin-right: 35px !important
}

.blog-comments .comment-body {
    margin-top: 105px !important;
    border: 1px solid #e5e7eb !important
}

.blog-comments .comment-author {
    margin-top: -112px !important
}

.blog-comments .comment-metadata {
    margin-bottom: 56px !important
}

.blog-comments .comments-title {
    margin-bottom: 15px
}

.blog-comments #respond {
    margin-top: 36px !important
}

.blog-comments .reply a {
    padding: 8px !important;
    color: #4b5563 !important;
    background: #e5e7eb !important;
    font-size: 16px !important;
    font-weight: 500 !important
}

.blog-comments .comment-respond {
    background: #f3f4f6;
    border-radius: 8px;
    padding: 40px
}

.blog-comments #reply-title {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #334155;
    margin-bottom: 12px !important
}

.blog-comments .commentpolicy,
.blog-comments .logged-in-as {
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 18px !important;
    color: #374151 !important;
    max-width: 632px;
    margin-bottom: 30px !important
}

.blog-comments input[type=text],
.blog-comments textarea {
    width: 100%
}

.blog-comments .comment-form-cookies-consent label {
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #334155 !important
}

.blog-comments input[type=submit] {
    border-radius: 4px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    padding: 12px 24px !important
}

input[type=text],
input[type=password],
input[type=email],
input[type=url],
input[type=date],
input[type=month],
input[type=time],
input[type=datetime],
input[type=datetime-local],
input[type=week],
input[type=number],
input[type=search],
input[type=tel],
input[type=color],
select,
textarea {
    font-family: inter, sans-serif !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .1) !important;
    border-radius: 4px !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #374151 !important
}

.wp-blocks-headers {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 15px !important;
    margin-top: 20px !important
}

.wp-blocks-description {
    margin-bottom: 34px !important
}

.sp-block-list .sp-el-col {
    background: #fff;
    border: 1.5px solid #e2e8f0 !important;
    border-radius: 7px !important;
    min-height: 152px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-block: 10px
}

.sp-block-list .sp-el-col img {
    width: 44px !important
}

.sp-block-list .wp-block-headline img {
    width: 34px !important
}

.sp-block-list .sp-el-col p {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px
}

.pricing-14-days {
    position: absolute;
    margin-top: -100px !important
}

.pricing-info {
    margin-top: -170px !important
}

.pricing-header {
    max-width: 975px !important;
    margin-left: auto !important;
    margin-right: auto !important
}

.pricing-what-people-are-saying-header {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px
}

.pricing-table__plan {
    background-color: #fff
}

.help-question-icon {
    margin-left: 8px
}

.storage-icon {
    margin-right: 8px
}

.feature-header {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px
}

.features-2-col-lg,
.features-2-col-sm,
.features-3-col .sp-el-col {
    border: 2px solid #efefef !important
}

.features-2-col-lg h3,
.features-2-col-sm h3,
.features-3-col .sp-el-col h3 {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 24px !important;
    text-align: left
}

.features-2-col-lg .sp-css-description p,
.features-2-col-sm .sp-css-description p,
.features-3-col .sp-el-col .sp-css-description p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #353535;
    margin-bottom: 0 !important
}

.features-2-col-sm,
.features-2-col-lg {
    padding: 40px !important
}

.features-3-col div.sp-col-empty {
    border: none !important
}

.integrations-rows div.sp-col-empty {
    border: none !important
}

.features-2-col-sm,
.features-2-col-lg,
.features-3-col .sp-el-col {
    display: flex;
    flex-direction: column;
    justify-content: flex-end
}

.features-3-col,
.features-2-col {
    gap: 20px
}

.features-2-col {
    min-height: 442px !important
}

.features-2-col-lg .sp-text-wrapper {
    max-width: 344px
}

.highlight-feature-1 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-1 .sp-feature-wrapper img {
    margin-left: 40px
}

.highlight-feature-1 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-2 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-2 .sp-feature-wrapper img {
    margin-left: 40px;
    margin-bottom: -42px
}

.highlight-feature-2 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-3 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-3 .sp-feature-wrapper img {
    margin-left: 0;
    margin-right: -40px;
    margin-top: -21px;
    position: relative;
    top: -33px
}

.highlight-feature-3 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-4 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-4 .sp-feature-wrapper img {
    margin-left: 40px;
    margin-right: -20px;
    position: relative;
    top: -129px
}

.highlight-feature-4 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-5 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-5 .sp-feature-wrapper img {
    margin-left: 40px;
    margin-bottom: -42px;
    margin-right: -40px
}

.highlight-feature-5 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-6 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-6 .sp-feature-wrapper img {
    margin-left: -46px;
    top: -20px;
    margin-right: -41px;
    position: relative;
    margin-bottom: -57px
}

.highlight-feature-6 .sp-feature-wrapper>div p {
    text-align: left
}

.highlight-feature-7 .sp-feature-wrapper>div {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-start
}

.highlight-feature-7 .sp-feature-wrapper img {
    position: relative;
    top: -218px
}

.highlight-feature-7 .sp-feature-wrapper>div p {
    text-align: left
}

.features-theme-builder-header {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    margin-top: 80px !important;
    margin-bottom: 50px !important;
    max-width: 549px;
    margin-left: auto !important;
    margin-right: auto !important
}

.feature-header-integrations {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 40px !important;
    line-height: 48px !important
}

.integrations-rows {
    gap: 56px;
    margin-bottom: 24px !important
}

.integrations-rows .sp-el-col {
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px
}

.integrations-rows .sp-el-col p {
    margin-top: 15px;
    margin-bottom: 12px;
    text-align: center
}

.features-nav a:hover {
    color: #171717 !important
}

.features-nav li:last-child a {
    color: #16a34a !important
}

.features-3-col img {
    margin-top: 30px !important;
    margin-bottom: 24px !important
}

.features-3-col p {
    margin-bottom: 30px !important
}

@media(max-width:640px) {
    .features-2-col {
        min-height: auto !important
    }

    .features-nav .sp-nav-wrapper {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px;
        justify-content: center
    }

    .features-3-col img {
        max-width: 60px !important
    }

    .features-3-col p {
        margin-bottom: 0 !important
    }

    .features-theme-builder-header {
        margin-top: 20px !important;
        margin-bottom: 20px !important
    }

    .features-2-col-lg.sp-el-col,
    .features-2-col-sm.sp-el-col {
        padding: 16px !important
    }

    .features-2-col,
    .features-3-col {
        display: flex !important;
        flex-direction: column !important;
        gap: 24px !important
    }

    .features-2-col.sp-el-row,
    .features-3-col.sp-el-row {
        margin-bottom: 16px !important
    }

    .features-2-col-sm .sp-feature-wrapper {
        text-align: left !important
    }

    .features-2-col-lg .sp-type-header {
        margin-top: 140px !important
    }

    .features-2-col-lg h3,
    .features-2-col-sm h3 {
        font-weight: 700 !important;
        font-size: 20px !important;
        line-height: 24px !important;
        text-align: left !important
    }

    .features-2-col-lg p,
    .features-2-col-sm p,
    .features-3-col p {
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 24px !important
    }

    .features-3-col.sp-el-row {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .features-3-col .sp-feature-wrapper {
        display: flex !important;
        padding: 16px !important
    }

    .features-3-col h3 {
        text-align: left !important;
        font-weight: 700 !important;
        font-size: 20px !important;
        line-height: 24px !important
    }

    .features-3-col .sp-css-description {
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 24px !important
    }

    .integrations-rows {
        justify-content: center !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 30px !important;
        align-items: center !important;
        margin-bottom: 0 !important
    }

    .integrations-rows .sp-el-col {
        max-width: 211px
    }

    .features-2-col-lg .sp-feature-wrapper img {
        display: none !important
    }

    .feature-image-3-mobile img {
        margin-right: -38px
    }

    .feature-image-4-mobile img {
        margin-right: -38px;
        margin-bottom: -61px
    }
}

@media(max-width:1100px) {
    .global-cta {
        background-size: cover !important
    }
}

@media(max-width:640px) {
    .pabloo-hero-tagline p {
        text-align: center !important;
        font-size: 14px;
        line-height: 22px
    }

    .hero-main-image {
        margin-bottom: -83px !important
    }

    .pabloo-top-6-advantages {
        display: flex !important;
        flex-wrap: wrap !important;
        margin-top: -20px !important
    }

    .pabloo-top-6-advantages .sp-el-col {
        width: 33.333% !important
    }

    .pabloo-top-6-advantages .sp-text-wrapper {
        padding: 0 !important
    }

    .pabloo-top-6-advantages .sp-text-wrapper p {
        text-align: center !important;
        font-size: 12px !important;
        line-height: 18px !important
    }

    .home-hero-button {
        width: auto !important;
        padding: 12px 50px !important;
        margin-top: -10px !important;
        margin-bottom: -60px !important
    }

    .home-hero-button strong {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px
    }

    .home-trust-badges {
        display: flex !important;
        flex-wrap: wrap !important;
        margin-top: 60px !important;
        margin-bottom: 40px !important
    }

    .home-hero-image {
        margin-top: -10px !important
    }

    .home-hero-companies {
        margin-top: -32px !important
    }

    .home-hero-companies .sp-text-wrapper p {
        text-align: center !important;
        font-size: 10px !important;
        line-height: 10px !important
    }

    .home-section1-header {
        font-weight: 700 !important;
        font-size: 22px !important;
        line-height: 30px !important;
        margin-top: 20px !important
    }

    .home-section1-desc p,
    .home-section1-desc {
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 18px !important;
        text-align: center !important
    }

    .home-section1-desc {
        margin-bottom: 0 !important
    }

    .home-section1-features .sp-el-col {
        margin-bottom: 0 !important
    }

    .home-section1-features.sp-el-row {
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .home-section1-features .sp-feature-wrapper {
        display: flex !important;
        padding: 16px !important
    }

    .home-section1-features h3 {
        text-align: left !important;
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 24px !important
    }

    .home-section1-features .sp-css-description,
    .home-section1-features p {
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 18px !important
    }

    .home-templates-title {
        font-size: 22px;
        line-height: 30px
    }

    .home-templates-desc {
        font-size: 14px !important;
        line-height: 18px !important;
        text-align: center !important
    }

    .home-section1-cta {
        margin-top: -26px !important
    }

    .home-section1-cta .sp-text-wrapper {
        text-align: center !important
    }

    .home-section1-cta .sp-text-wrapper a {
        text-align: center !important;
        display: inline-block !important;
        margin-left: 0 !important
    }

    .home-testimonial-tagline {
        display: flex !important
    }

    .home-testimonials .sp-el-col {
        margin-bottom: 16px !important;
        min-height: auto !important
    }

    .home-testimonials .sp-testimonial-comment {
        font-weight: 500 !important;
        font-size: 18px !important;
        line-height: 28px !important;
        margin-bottom: 8px !important;
        padding-top: 0 !important
    }

    .home-testimonials small strong {
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 24px !important
    }

    #home-heart-header {
        max-width: 700px !important;
        font-size: 22px !important;
        line-height: 30px !important
    }

    #home-heart-header img {
        width: 25px !important
    }

    .home-heart-tagline p {
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 18px !important;
        text-align: center !important
    }

    .home-top-7-row2,
    .home-top-7-row4,
    .home-top-7-row6 {
        display: flex !important;
        flex-direction: column-reverse !important
    }

    .home-top-7-row {
        gap: 0 !important
    }

    .home-top-7-row h3 {
        text-align: left !important
    }

    .home-section1-see-all {
        margin-top: 10px !important
    }

    .home-section1-cta {
        margin-bottom: 0 !important
    }

    .home-testimonials .sp-testimonial-wrapper {
        padding-bottom: 0 !important
    }

    .global-cta-wrapper.sp-el-section,
    .global-cta-wrapper .sp-el-row,
    .global-cta-wrapper .sp-el-col {
        padding: 0 !important;
        margin-left: 0 !important;
        margin-right: 0 !important
    }

}

.testimonials-main-stats {
    gap: 60px
}

.testimonials-page-3-col .sp-el-col {
    background: #fff;
    box-shadow: 0 0 2px rgba(0, 0, 0, .2), 0 2px 10px rgba(0, 0, 0, .1);
    border-radius: 8px;
    border: none !important;
    font-weight: 400;
    font-size: 12px !important;
    line-height: 20px !important
}

.testimonials-page-3-col .sp-el-col strong {
    font-weight: 600 !important
}

.testimonials-page-description {
    max-width: 870px;
    margin-bottom: 100px !important
}

.testimonials-page-3-col {
    gap: 20px
}

.testimonial-badges {
    margin-top: 30px !important
}

.testimonial-badges .sp-text-wrapper {
    position: relative;
    top: -46px;
    left: -24px
}

.testimonials-global-cta-wrapper {
    margin-top: 40px !important;
    margin-bottom: 50px !important
}

@media(max-width:640px) {
    .testimonials-page-description {
        margin-bottom: 16px !important
    }

    .testimonials-main-stats {
        display: flex !important;
        gap: 12px !important
    }

    .testimonials-main-stats h2 {
        font-size: 20px !important;
        padding-bottom: 8 !important;
        padding-bottom: 0 !important
    }

    .testimonials-main-stats .sp-text-wrapper p {
        font-size: 12px !important;
        text-align: center !important
    }

    .testimonial-badges {
        margin-top: 0 !important
    }

    .testimonial-badges p {
        text-align: center !important
    }

    .home-hero-button.testimonials-button {
        margin-top: 16px !important
    }

    #sp-ov14bq .sp-button-wrapper {
        margin-top: -33px !important;
        margin-bottom: 15px !important
    }

    .testimonials-page-3-col {
        display: flex !important;
        flex-direction: column !important;
        gap: 24px !important
    }

    .testimonial-page-3-col .sp-text-wrapper {
        margin-bottom: 10px !important
    }

    .testimonial-page-3-col .sp-el-block {
        padding-top: 0 !important
    }

    .testimonials-global-cta-wrapper {
        margin-top: 20px !important;
        margin-bottom: 30px !important
    }

    .testimonials-hero-button {
        padding: 16px 32px !important
    }

    .testimonials-hero-button strong {
        font-size: 16px !important;
        line-height: 24px !important
    }
}

.lite-upgrade-page-description {
    max-width: 850px;
    margin-left: auto !important;
    margin-right: auto !important
}

.lite-upgrade-global-feature-grid-wrapper .home-section1-header,
.lite-upgrade-global-feature-grid-wrapper .home-section1-desc,
.lite-upgrade-global-feature-grid-wrapper .sp-spacer,
.lite-upgrade-global-feature-grid-wrapper .home-section1-see-all:after {
    display: none
}

.lite-pro-comparison-section h1 {
    font-family: 'ibm plex serif';
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 48px
}

.wordpress-block-sp-nav li:last-child a {
    color: #16a34a !important
}

@media(max-width:640px) {
    .sp-block-list {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 10px !important
    }

    .sp-block-list .sp-el-col {
        width: 46% !important
    }

    .sp-block-list .sp-el-col p {
        text-align: center
    }
}

.section-contact h2 {
    font-family: 'ibm plex serif';
    font-weight: 700;
    font-size: 24px;
    line-height: 32px
}

.contact-us-adv-btn,
.contact-us-basic-btn {
    padding: 15px 20px !important;
    width: 289px !important
}

.contact-us-basic-btn {
    border-width: 2px !important
}

.section-contact {
    gap: 17px
}

@media(max-width:640px) {
    .section-contact {
        display: flex;
        flex-direction: column;
        gap: 24px
    }

    .section-contact .sp-el-col {
        padding: 12px !important
    }

    .section-contact .sp-type-header {
        font-weight: 700 !important;
        font-size: 18px !important;
        line-height: 28px !important
    }

    .section-contact .sp-text-wrapper p {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        text-align: center
    }
}

#theme-pabloo-body {
    background-color: #fff
}

.pabloo-theme-header {
    position: relative;
    background-color: #fff4e4;
    width: 100%;
    max-width: 100%;
    padding: 20px
}

.pabloo-theme-header-inner {
    max-width: 900px;
    margin: 0 auto;
    text-align: center
}

.pabloo-theme-header-inner h1 {
    font-size: 40px;
    text-align: center;
    margin: 0;
    padding-top: 54px;
    padding-bottom: 3px;
    color: #171717;
    font-weight: 700;
    font-style: normal
}

.pabloo-theme-header-inner p {
    font-size: 18px;
    margin: 0;
    font-weight: 500;
    padding: 10px;
    padding-bottom: 70px;
    color: #374151
}

@media(max-width:640px) {
    .pabloo-theme-header-inner h1 {
        font-weight: 700 !important;
        font-size: 24px !important;
        line-height: 32px !important
    }

    .pabloo-theme-header-inner p {
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        padding: 10px
    }
}

#hkb .hkb-fullwcontainer {
    width: 100% !important
}

#docs-home {
    background: #fff;
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 60px;
    padding-bottom: 80px
}

#docs-home__categories {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px
}

.docs-home__category {
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    width: 100%;
    max-width: 413px;
    text-align: center;
    padding: 32px
}

.docs-home__category h2 {
    font-family: inter, sans-serif !important;
    font-weight: 700;
    font-size: 19px;
    line-height: 150%;
    color: #171717;
    margin-bottom: 16px
}

.docs-home__category a {
    box-sizing: border-box;
    font-weight: 700;
    font-size: 15px;
    line-height: 100%;
    color: #353535;
    background: #fff;
    border: 1px solid #16a34a;
    border-radius: 4px;
    padding: 12px 20px 13px;
    display: inline-block
}

.docs-home__category a:hover {
    color: #16a34a
}

#hkb .hkb-searchbox-wrapper[data-hkb-header-type=solid] {
    background: #fff !important
}

.hkb-searchbox__title {
    display: none
}

#hkb .hkb-container {
    max-width: 1320px !important;
    padding: 0 20px !important
}

#hkb .hkb-searchbox {
    max-width: 1280px !important
}

#hkb .hkb-searchbox .hkb-site-search__field {
    max-width: 1280px !important;
    margin: 0 !important;
    padding: 24px 64px !important;
    box-shadow: none !important
}

#hkb .hkb-site-search .hkb-site-search__icon {
    position: relative;
    left: 14px;
    height: 20px;
    width: 20px;
    top: 50%;
    margin-top: -10px;
    fill: #6b7280
}

#hkb .hkb-site-search .hkb-site-search__icon path {
    fill: #fff !important
}

#hkb .hkb-searchbox .hkb-site-search__field::placeholder {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #6b7280
}

#hkb .hkb-searchbox-wrapper {
    padding: 40px 0 !important
}

#docs-home__search .hkb-container {
    padding: 0 !important
}

#docs-home__gettingstarted {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    position: relative
}

#docs-home__gettingstarted .widget-title {
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: #334155;
    padding: 26px 40px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 0 !important
}

#docs-home__gettingstarted li {
    position: relative;
    padding: 0 0 0 30px;
    background: 0 0;
    list-style: none;
    text-indent: 0;
    margin: 0 0 20px !important;
    line-height: unset;
    width: 50%;
    border-bottom: none !important
}

#docs-home__gettingstarted ul {
    padding: 46px 40px 14px;
    display: flex;
    flex-wrap: wrap;
    width: 100%
}

#docs-home__gettingstarted li a {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #334155
}

.docs-submit-a-ticket {
    background: #16a34a;
    border-radius: 40px;
    padding: 9px 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #f9fafb;
    display: inline-block;
    position: absolute;
    right: 40px;
    top: 24px
}

.docs-submit-a-ticket:hover {
    color: #f9fafb
}


@media(max-width:640px) {
    #docs-home {
        margin-top: 46px
    }

    #docs-home__categories {
        margin-left: 25px;
        margin-right: 25px
    }

    .docs-home__category {
        margin-bottom: 0
    }

    #docs-home__search {
        margin-left: 25px;
        margin-right: 25px
    }

    #hkb .hkb-searchbox .hkb-site-search__field::placeholder {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: #6b7280
    }

    #hkb .hkb-searchbox .hkb-site-search__field {
        padding: 12px 40px !important
    }

    .hkb-site-search:after {
        top: 9px;
        left: 6px;
        position: absolute
    }

    #docs-home__gettingstarted {
        margin-left: 25px;
        margin-right: 25px
    }

    #docs-home__gettingstarted .widget-title {
        font-weight: 700;
        font-size: 20px;
        line-height: 32px;
        padding: 20px
    }

    #docs-home__gettingstarted ul {
        padding: 25px;
        display: block;
        width: 100%
    }

    #docs-home__gettingstarted li {
        width: 100%
    }

    #docs-home__gettingstarted li a {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px
    }

    #docs-home__gettingstarted {
        display: flex;
        flex-direction: column
    }

    .docs-submit-a-ticket {
        position: relative;
        display: inline-block;
        right: initial;
        top: initial;
        text-align: center
    }
}

@media screen and (min-width:770px) {

    #hkb .hkb-mainpage.hkb-mainpage--sidebarleft .hkb-mainpage__sidebar,
    #hkb .hkb-mainpage.hkb-mainpage--sidebarright .hkb-mainpage__sidebar {
        width: 32% !important
    }
}

@media screen and (min-width:770px) {
    #hkb .hkb-mainpage.hkb-mainpage--sidebarleft .hkb-mainpage__sidebar {
        margin-right: 65px !important
    }
}

.hkb-mainpage__main {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 45px
}

.hkb-categoryheader__icon,
.hkb-categoryheader__description,
.hkb-articlepreview__excerpt,
.hkb_widget_categories .widget-title {
    display: none !important
}

.hkb-mainpage__sidebar .widget {
    border: 1px solid #e5e7eb;
    border-radius: 8px !important;
    padding: 40px !important;
    padding-bottom: 20px !important;
    margin-bottom: 20px !important;
    background: #fff !important
}

.hkb_widget_categories {
    font-weight: 700;
    font-size: 19px;
    line-height: 150%;
    color: #2a3851
}

.hkb_widget_categories li,
.hkb_widget_articles li {
    border-bottom: 1px solid #f1f1f6;
    padding-bottom: 12px !important
}

.hkb_widget_categories li:last-of-type,
.hkb_widget_articles li:last-of-type {
    border-bottom: none
}

.hkb_widget_categories .current-cat {
    color: #fe4715
}

.hkb_widget_articles .widget-title {
    font-weight: 700;
    font-size: 19px;
    line-height: 150%;
    color: #171717;
    margin-bottom: 30px !important
}

.hkb_widget_articles a {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #2a3851 !important
}

.hkb_widget_articles li {
    margin: 0 0 12px !important;
    padding-left: 30px !important
}

.hkb-categoryheader__title {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #171717
}

#hkb .hkb-categoryheader {
    border-bottom: none !important;
    margin-bottom: 6px !important
}

#hkb .hkb-articlepreview {
    padding: 10px 0 !important;
    border-bottom: none !important
}

.hkb-articlepreview__title a {
    position: relative;
    font-weight: 500 !important;
    font-size: 18px;
    line-height: 160%;
    color: #2a3851 !important;
    padding-left: 35px !important
}

.hkb_widget_toc {
    color: #2a3851 !important
}

#hkb .hkb_widget_toc ol li.active>a {
    background: #fe4715 !important
}

.hkb-article {
    color: #2a3851 !important;
    font-weight: 500;
    font-size: 18px;
    line-height: 160%
}

h1.hkb-article__title,
.hkb-article h1,
.hkb-article h2,
.hkb-article h3 {
    color: #171717 !important
}

h1.hkb-article__title {
    margin-bottom: 32px !important;
    font-weight: 700 !important;
    font-size: 32px !important;
    line-height: 40px !important
}

#docs-sidebar__search .hkb-container {
    padding: 0 !important
}

#docs-sidebar__search #hkb .hkb-searchbox .hkb-site-search__field {
    padding: 12px 40px !important;
    background-color: #f9fafb;
    border: 1px solid #e5e7eb !important;
    border-radius: 4px !important
}

#docs-sidebar__search .hkb-searchbox-wrapper {
    padding: 0 !important;
    padding-bottom: 20px !important
}

#docs-sidebar__search ::placeholder {
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #6b7280 !important
}

i.solution {
    display: block;
    width: fit-content;
    background-color: #15955f;
    color: #fff;
    padding: 5px 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 5px
}

i.problem {
    display: block;
    width: fit-content;
    background-color: #d63638;
    color: #fff;
    padding: 5px 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 5px
}

@media(max-width:640px) {
    .hkb-mainpage__main {
        border: none !important;
        padding: 0 !important
    }

    h1.hkb-article__title,
    .hkb-article h1,
    .hkb-article h2,
    .hkb-article h3 {
        text-align: left !important
    }

    .hkb-article h2,
    .hkb-article h3 {
        font-size: 18px !important
    }

    h1.hkb-article__title {
        margin-bottom: 24px !important;
        font-weight: 700 !important;
        font-size: 20px !important;
        line-height: 30px !important
    }

    .hkb-article {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px
    }

    .hkb-mainpage__sidebar .widget {
        border: none !important;
        padding: 0 !important
    }

    .hkb_widget_toc {
        display: none
    }

    .hkb-categoryheader__title {
        font-weight: 700 !important;
        font-size: 19px !important;
        line-height: 150% !important
    }

    .hkb-articlepreview__title {
        text-align: left !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 18px !important
    }

    .hkb_widget_articles .widget-title {
        text-align: left !important
    }

    #hkb .hkb-mainpage-wrapper {
        padding: 3em 0 2em !important
    }
}

#docs-optin {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 32px
}

#docs-optin h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #171717;
    margin-bottom: 32px !important
}

#docs-optin input {
    padding: 12px;
    background: #f9fafb;
    border: 1px solid #e5e7eb !important;
    border-radius: 4px !important;
    box-shadow: none !important;
    margin-bottom: 16px
}

#docs-optin button {
    background: #fe4715;
    border-radius: 4px !important;
    padding: 12px 40px !important;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px
}

.sidebar-follow {
    display: flex;
    color: #334155;
    margin-top: 40px !important
}

@media(max-width:640px) {
    #docs-optin {
        border: none;
        padding: 0
    }

    #docs-optin.sp-el-col,
    #docs-optin .sp-el-block {
        padding: 0 !important
    }

    .sidebar-follow {
        margin-top: 20px !important
    }

    #docs-optin h3 {
        text-align: left !important;
        margin-bottom: 16px !important;
        padding: 0 !important
    }
}

.home-template-switcher {
    margin-top: 10px;
    margin-bottom: 37px;
    display: flex
}

.home-template-switcher-col-1 {
    min-width: 300px;
    display: flex;
    align-items: center
}

.home-template-switcher-col-1 ul {
    list-style: none;
    padding: 0;
    margin: 0
}

.home-template-switcher-col-1 ul a {
    font-family: 'ibm plex serif';
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: #74a3b8;
    margin-bottom: 24px;
    display: inline-block
}

.home-template-switcher-col-1 ul a.active {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #171717
}

@media(max-width:640px) {
    .home-template-switcher {
        flex-direction: column
    }

    .home-template-switcher-col-1 {
        display: none
    }
}

.page-functionality-list ul li {
    font-family: 'ibm plex serif'
}

.pabloo-pages-hero-tagline {
    font-weight: 600;
    text-align: center;
    font-style: normal;
    margin-left: auto !important;
    margin-right: auto !important
}

.pabloo-pages-hero-bottom-hearder {
    font-weight: 400;
    text-align: center;
    font-style: normal;
    margin-left: auto !important;
    margin-right: auto !important
}

.theme-page-main-image {
    margin-bottom: -430px !important
}

.theme-page-main-image-2 {
    margin-bottom: -290px !important
}

.pages-image-box-feature img {
    align-self: flex-start;
    margin-bottom: 24px
}

.pages-image-box-feature p {
    font-family: inter, sans-serif !important;
    font-weight: 400;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px
}

.pages-image-box-feature p a,
.pages-template-text-description p a {
    text-decoration: none;
    color: #353535 !important
}

.pages-image-box-feature {
    margin-bottom: 0 !important
}

.pages-image-box-feature .sp-text-center {
    text-align: left
}

.pages-image-box-feature h3 {
    font-family: manrope, sans-serif !important;
    text-align: left;
    font-weight: 700;
    font-size: 20px !important;
    line-height: 24px !important;
    margin-bottom: 12px
}

.pages-image-box-feature .sp-css-description {
    font-weight: 400
}

.theme-pages-feature-list li {
    font-family: 'ibm plex serif';
    line-height: 28px
}

.theme-pages-feature-list-2 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-3 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-4 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-5 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-6 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-7 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-8 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-9 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-10 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-11 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-12 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-13 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-14 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-15 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-16 li {
    font-family: 'ibm plex serif';
    line-height: 32px
}

.theme-pages-feature-list-action-button {
    font-family: inter, sans-serif !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 700 !important;
    line-height: 24px;
    background: #16a34a;
    color: #fff;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px
}

.theme-pages-feature-grid {
    padding-top: 410px !important
}

.theme-page-testimonials .testimonial-grid {
    max-height: 600px !important
}

.theme-page-testimonials .testimonial-grid .testimonial {
    width: 30% !important;
    max-width: 30% !important
}

.theme-page-heart-tagline p {
    font-family: inter, sans-serif !important;
    font-weight: 400 !important;
    font-size: 18px;
    line-height: 26px !important;
    text-align: center !important;
    width: 588px;
    text-align: center
}


@media(max-width:1000px) {

    .theme-pages-feature-list-3 li,
    .theme-pages-feature-list-4 li,
    .theme-pages-feature-list-5 li,
    .theme-pages-feature-list-6 li,
    .theme-pages-feature-list-7 li,
    .theme-pages-feature-list-8 li,
    .theme-pages-feature-list-9 li,
    .theme-pages-feature-list-10 li,
    .theme-pages-feature-list-11 li,
    .theme-pages-feature-list-12 li,
    .theme-pages-feature-list-13 li,
    .theme-pages-feature-list-14 li,
    .theme-pages-feature-list-15 li,
    .theme-pages-feature-list-16 li {
        font-size: 16px !important;
        padding-bottom: 5px !important;
        margin-top: 5px !important
    }

    .theme-pages-feature-list-3,
    .theme-pages-feature-list-4,
    .theme-pages-feature-list-5,
    .theme-pages-feature-list-6,
    .theme-pages-feature-list-7,
    .theme-pages-feature-list-8,
    .theme-pages-feature-list-9,
    .theme-pages-feature-list-10,
    .theme-pages-feature-list-11,
    .theme-pages-feature-list-12,
    .theme-pages-feature-list-13,
    .theme-pages-feature-list-14,
    .theme-pages-feature-list-15,
    .theme-pages-feature-list-16 {
        margin-top: 5px !important
    }
}

@media(max-width:640px) {
    .theme-pages-feature-images img {
        height: auto !important;
        width: max-content !important
    }

    .theme-page-main-image img {
        height: auto !important;
        width: max-content !important
    }

    .theme-pages-feature-grid,
    #sp-qashqp,
    #sp-jfish0,
    #sp-q091f5,
    #sp-vd4wrb,
    #sp-ryaisf,
    #sp-scazoy,
    #sp-li3zfm,
    #sp-g2t3cx,
    #sp-jzpbk6 {
        padding-top: 300px !important
    }

    #sp-qlxt13,
    #sp-qh7qtr {
        padding-top: 250px !important
    }

    .theme-page-main-image-2 img {
        margin-top: -60px !important;
        height: auto !important;
        width: max-content !important
    }

    #sp-nz9mup {
        margin-bottom: 200px !important
    }

    .theme-pages-feature-list {
        margin-top: 0 !important
    }

    .theme-page-testimonials .testimonial-grid {
        max-height: fit-content !important
    }

    .pages-image-box-feature h3 {
        font-family: manrope, sans-serif !important;
        text-align: left;
        font-weight: 700;
        font-size: 18px !important;
        margin-bottom: 12px
    }

    .theme-page-heart-tagline p {
        font-family: inter, sans-serif !important;
        font-weight: 400 !important;
        font-size: 14px;
        line-height: 26px !important;
        text-align: center !important;
        text-align: center
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/hero-pablooprod/pablooprodStyle.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,gCAAgC;IAChC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;;;;;;QAMI,aAAa;QACb,8BAA8B;QAC9B;IACJ;;;IAGA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,aAAa;QACb,aAAa;QACb;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd;IACJ;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI,gCAAgC;QAChC,oBAAoB;QACpB;IACJ;;IAEA;;;QAGI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B;AACJ;;AAEA;;;;IAII,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;;;QAII,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;;;;;;;;;;;;;;QAeI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,+CAA+C;IAC/C,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAgBA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;IACvC;AACJ;;AAgBA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B;AACJ;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,2BAA2B;IAC3B,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,oBAAoB;QACpB,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;;;QAKI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,8BAA8B;IAC9B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B;AACJ;;AAEA;;;;;;;;;;;;;;;;IAgBI,yCAAyC;IACzC,oCAAoC;IACpC,kDAAkD;IAClD,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;;;IAGI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;IAChB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI,wBAAwB;QACxB,iCAAiC;QACjC;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;;;QAGI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,kCAAkC;QAClC,wBAAwB;QACxB,iCAAiC;QACjC,oBAAoB;QACpB,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,4BAA4B;QAC5B;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;QAC1B,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,yBAAyB;QACzB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;QAChC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;;;QAGI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,qBAAqB;QACrB,yBAAyB;QACzB;IACJ;;AAEJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mEAAmE;IACnE,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,wBAAwB;QACxB,iCAAiC;QACjC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,4BAA4B;QAC5B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAgBA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAgBA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR,SAAS;QACT;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,aAAa;QACb,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,cAAc;QACd,YAAY;QACZ;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,+BAA+B;IAC/B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,gCAAgC;IAChC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,oCAAoC;IACpC;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAgBA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI,2BAA2B;QAC3B,2BAA2B;QAC3B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;IAC7B,2BAA2B;IAC3B;AACJ;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;IAC3B,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ;AACJ;;;AAGA;;IAEI;;;;;;;;;;;;;;QAcI,0BAA0B;QAC1B,8BAA8B;QAC9B;IACJ;;IAEA;;;;;;;;;;;;;;QAcI;IACJ;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;;;;;;;;;;QAUI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,4BAA4B;QAC5B,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2CAA2C;QAC3C,gBAAgB;QAChB,gBAAgB;QAChB,0BAA0B;QAC1B;IACJ;;IAEA;QACI,yCAAyC;QACzC,2BAA2B;QAC3B,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;QAC7B;IACJ;AACJ","sourcesContent":["pre:empty {\n    display: none\n}\n\n.gutter,\n.gutter-horizontal {\n    display: none\n}\n\n.pabloo-theme {\n    font-weight: 400;\n    font-family: inter, sans-serif !important\n}\n\n.pabloo-hero-tagline {\n    font-weight: 500;\n    max-width: 844px;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.sp-button {\n    display: inline-flex !important;\n    justify-content: center !important;\n    align-items: center !important\n}\n\n.pabloo-global-header {\n    padding: 0 !important\n}\n\n.pabloo-site-header {\n    background: #fff;\n    z-index: 999;\n    width: 100%\n}\n\n.home-hero-image img {\n    width: 1378px;\n    max-width: 100%\n}\n\n.pabloo-header-container {\n    max-width: 1300px;\n    padding: 0 10px;\n    margin: 0 auto;\n    display: flex;\n    align-items: center;\n    min-height: 80px\n}\n\n#pabloo-desktop-menu-links {\n    padding-left: 45px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between\n}\n\n#pabloo-desktop-menu-links ul {\n    list-style-type: none;\n    display: flex;\n    gap: 24px;\n    align-items: center\n}\n\n#pabloo-desktop-menu-links li {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 26px\n}\n\n#pabloo-desktop-menu-links li a {\n    color: #353535;\n    text-decoration: none;\n    font-family: inter;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px\n}\n\n#pabloo-desktop-menu-cta a {\n    background: #16a34a;\n    color: #fff !important;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 7px 24px;\n    gap: 4px;\n    border: 1px solid #16a34a;\n    border-radius: 40px;\n    font-weight: 700 !important;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.pabloo-mobile-menu {\n    display: none\n}\n\n.pabloo-mobile-menu-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 58px;\n    padding: 0 24px\n}\n\n#pabloo-menu-close {\n    display: none\n}\n\n#pabloo-mobile-menu-navigation {\n    display: none\n}\n\n#pabloo-mobile-menu-cta-header {\n    padding-top: 15px;\n    margin-bottom: 16px;\n    color: #fff;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n    text-align: center\n}\n\n#pabloo-mobile-menu-cta a {\n    background: #fe4715;\n    color: #fff;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 8px 16px;\n    gap: 6px;\n    border-radius: 4px;\n    font-weight: 700;\n    font-size: 11.3418px;\n    line-height: 17px\n}\n\n#pabloo-mobile-menu-cta img {\n    width: 250px;\n    margin: auto;\n    display: block\n}\n\n#pabloo-mobile-menu-links {\n    background-color: #fff;\n    padding: 24px\n}\n\n#pabloo-mobile-menu-links ul {\n    list-style-type: none\n}\n\n#pabloo-mobile-menu-links li {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 28px;\n    padding-bottom: 24px\n}\n\n#pabloo-mobile-menu-links li a {\n    color: #171717;\n    text-decoration: none\n}\n\n#pabloo-desktop-menu-hover-help {\n    position: absolute;\n    z-index: 10;\n    width: 610px;\n    background: #fff;\n    left: -254px;\n    padding: 40px;\n    display: flex;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #374151;\n    top: 60px;\n    display: none;\n    box-shadow: 0 4px 4px #f7f2ea\n}\n\n.help-has-dropdown a {\n    display: flex;\n    align-items: center\n}\n\n.help-has-dropdown svg {\n    margin-left: 10px;\n    margin-right: 4px\n}\n\n#hover-top-arrow {\n    position: absolute;\n    top: -18px;\n    left: 286px\n}\n\n#pabloo-desktop-menu-hover-help-1 {\n    display: flex;\n    flex-direction: column;\n    width: 52%\n}\n\n#pabloo-desktop-menu-hover-help-1 a {\n    margin-bottom: 16px;\n    color: #374151\n}\n\n#pabloo-desktop-menu-hover-help-2 {\n    border: 1px solid #e5e7eb\n}\n\n#pabloo-desktop-menu-hover-help-3 {\n    display: flex;\n    flex-direction: column;\n    padding-left: 63px\n}\n\n#pabloo-desktop-menu-hover-help-3 span {\n    display: block;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: .96px;\n    text-transform: uppercase;\n    color: #9ca3af;\n    margin-bottom: 16px\n}\n\n#pabloo-desktop-menu-hover-help-3 a {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: -.355556px;\n    color: #334155;\n    margin-bottom: 4px;\n    display: flex;\n    align-items: center\n}\n\n#pabloo-desktop-menu-hover-help-3 a svg {\n    margin-left: 8px\n}\n\n#pabloo-desktop-menu-hover-help-3 p {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    letter-spacing: -.355556px;\n    color: #374151\n}\n\n@media(max-width:950px) {\n    .pabloo-mobile-menu {\n        display: block\n    }\n\n    .pabloo-desktop-menu {\n        display: none\n    }\n\n    .pabloo-site-branding {\n        width: 150px\n    }\n\n    .sp-el-section.pabloo-site-header-wrapper,\n    .pabloo-site-header-wrapper .sp-el-row,\n    .pabloo-site-header-wrapper .sp-el-col,\n    .pabloo-site-header-wrapper .sp-el-block {\n        padding: 0 !important\n    }\n\n    .mobile-center {\n        text-align: center;\n    }\n}\n\n.pabloo-global-footer {\n    padding: 0 !important\n}\n\n.pabloo-site-footer {\n    background: #fff;\n    z-index: 999;\n    width: 100%\n}\n\n.home .pabloo-site-footer .sp-section-shape .pabloo-shape-fill {\n    fill: #edf8fc\n}\n\n#footer-cta {\n    background-color: #ffe7f2;\n    width: 1368px;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 12px;\n    overflow: hidden;\n    min-height: 300px\n}\n\n#footer-cta-content {\n    display: flex;\n    margin: 0 auto;\n    justify-content: space-between\n}\n\n#footer-cta-1 {\n    max-width: 570px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 44px\n}\n\n#footer-cta-1 .h1 {\n    color: #171717;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 42px;\n    font-family: 'ibm plex serif';\n    margin-bottom: 36px\n}\n\n#footer-cta-1 p {\n    color: #fff;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 28px\n}\n\n#footer-cta-1 a {\n    background: #16a34a;\n    border-radius: 40px;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: #f9fafb;\n    padding: 15px 54px;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 20px;\n    text-decoration: none !important;\n    width: 289px\n}\n\n#footer-cta-2 {\n    position: relative;\n    display: flex\n}\n\n.footer-cta-screenshot {\n    width: 729px;\n    max-width: 100%;\n    height: auto;\n    align-self: flex-end\n}\n\n.footer-cta-arrow {\n    position: absolute;\n    right: -124px;\n    top: 73px\n}\n\n.footer-cta-screenshot-mobile {\n    display: none\n}\n\n#dup_integrations_action {\n    padding-bottom: 26px\n}\n\n@media(max-width:1050px) {\n    .footer-cta-arrow {\n        display: none\n    }\n\n    #footer-cta-2 {\n        margin-right: 0\n    }\n\n    #footer-cta-1 {\n        max-width: 50%\n    }\n}\n\n@media(max-width:640px) {\n    #dup_integrations_action {\n        display: none !important\n    }\n\n    .sp-el-section.pabloo-site-footer-wrapper,\n    .pabloo-site-footer-wrapper .sp-el-row,\n    .pabloo-site-footer-wrapper .sp-el-col,\n    .pabloo-site-footer-wrapper .sp-el-block {\n        padding: 0 !important\n    }\n\n    #footer-cta-content {\n        display: block;\n        padding: 0\n    }\n\n    #footer-cta-1 {\n        max-width: 100%\n    }\n\n    #footer-cta {\n        background-image: none;\n        border-radius: 0\n    }\n\n    #footer-cta-1 .h1 {\n        padding-top: 40px;\n        margin-top: 0 !important\n    }\n\n    #footer-cta-1 {\n        padding-left: 36px;\n        padding-right: 36px;\n        text-align: center\n    }\n\n    #footer-cta-1 a {\n        margin-left: auto;\n        margin-right: auto;\n        margin-top: 24px\n    }\n\n    #footer-cta-1 .h1 {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 36px;\n        margin-bottom: 8px;\n        position: relative;\n        z-index: 10\n    }\n\n    #footer-cta-1 p {\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 28px;\n        margin-bottom: 32px\n    }\n\n    .footer-cta-screenshot-mobile {\n        display: block\n    }\n\n    .footer-cta-screenshot {\n        display: none\n    }\n\n    .footer-cta-arrow {\n        display: block;\n        position: absolute;\n        right: 10px;\n        top: -363px;\n        height: 77px;\n        z-index: 0\n    }\n}\n\n#footer-links-main {\n    max-width: 1362px;\n    padding: 20px;\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 89px\n}\n\n#footer-links-main-1 {\n    width: 25%\n}\n\n#footer-links-main-2 {\n    width: 27%\n}\n\n#footer-links-main-3 {\n    width: 31%\n}\n\n#footer-links-main h3 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n    color: #171717;\n    margin-bottom: 24px\n}\n\n#footer-social {\n    display: flex;\n    flex-direction: row;\n    color: #334155;\n    margin-top: 8px\n}\n\n#footer-social a {\n    font-size: 17px !important;\n    margin-right: 10px\n}\n\n#footer-links-main ul,\n#footer-links-content ul,\n#footer-links-brands ul,\n#footer-sub ul {\n    list-style-type: none\n}\n\n#footer-links-main li,\n#footer-links-content li,\n#footer-links-brands li {\n    padding-bottom: 6px\n}\n\n#footer-links-main ul a,\n#footer-links-content ul a,\n#footer-links-brands ul a {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18px;\n    color: #171717\n}\n\n#footer-links-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    max-width: 1362px;\n    padding: 20px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n#footer-links-content-heading,\n#footer-links-brands-heading {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1362px;\n    padding: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    font-weight: 700;\n    font-size: 20px;\n    line-height: 150%;\n    color: #171717;\n    white-space: nowrap\n}\n\n#footer-links-content-heading {\n    padding-top: 60px;\n    padding-bottom: 0;\n    justify-content: flex-start\n}\n\n#footer-links-content-heading span,\n#footer-links-brands-heading span {\n    margin-left: 40px;\n    border-bottom: 1px solid #d1d5db;\n    width: 100%\n}\n\n#footer-links-brands-heading {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    max-width: 1362px;\n    padding: 20px;\n    padding-top: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n#footer-links-brands {\n    display: flex;\n    flex-direction: row;\n    max-width: 1362px;\n    padding: 20px;\n    padding-bottom: 42px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n#footer-links-brands-1 {\n    padding-right: 385px\n}\n\n#footer-links-brands-2 {\n    width: 24%\n}\n\n#footer-links-brands-1 div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    max-width: 390px;\n    margin-bottom: 21px\n}\n\n#footer-links-brands h4 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n    color: #171717;\n    text-align: left !important\n}\n\n#footer-links-brands-1 div img {\n    margin-right: 32px\n}\n\n#footer-links-brands-1 p {\n    max-width: 374px;\n    color: #353535\n}\n\n#footer-sub-div {\n    display: flex;\n    max-width: 1362px;\n    padding: 0 20px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n#footer-sub-div span {\n    border-top: 1px solid #000;\n    width: 100%\n}\n\n#footer-sub-wrapper {\n    background: #f1f5f9\n}\n\n#footer-sub {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    max-width: 1362px;\n    padding: 32px 20px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n#footer-sub p {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    color: #334155;\n    margin-bottom: 7px\n}\n\n#footer-sub ul {\n    display: flex;\n    flex-direction: row;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    text-decoration-line: underline\n}\n\n#footer-sub ul a {\n    color: #334155 !important;\n    font-weight: 500\n}\n\n#footer-sub ul li {\n    padding-right: 16px\n}\n\n#footer-sub-2 img:first-child {\n    max-width: 48px;\n    margin-right: 12px\n}\n\n#footer-social-wrapper {\n    display: none\n}\n\n@media(max-width:1000px) {\n    #footer-links-brands-1 {\n        padding-right: 20px\n    }\n}\n\n@media(max-width:800px) {\n    #footer-links-brands-1 p {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px\n    }\n\n    #footer-links-brands-1 div img {\n        margin-right: 22px\n    }\n\n    #footer-links-main {\n        display: block;\n        padding: 48px 24px 0 !important\n    }\n\n    #footer-links-main ul a {\n        font-size: 14px !important\n    }\n\n    #footer-links-main-1 ul li:last-child #footer-social a {\n        margin-right: 10px;\n        margin-top: 10px;\n        font-size: 20px !important\n    }\n\n    #footer-links h3 {\n        text-align: left !important\n    }\n\n    #footer-links-main>div {\n        width: 100%\n    }\n\n    #footer-links-main-2 h3,\n    #footer-links-main-3 h3,\n    #footer-links-main-4 h3 {\n        padding-top: 21px;\n        padding-bottom: 21px;\n        margin-bottom: 0\n    }\n\n    #footer-links-content-heading,\n    #footer-links-brands-heading {\n        font-size: 18px\n    }\n\n    #footer-links-content-heading span,\n    #footer-links-brands-heading span {\n        display: none\n    }\n\n    #footer-links-brands-1 {\n        margin-bottom: 20px\n    }\n\n    #footer-sub {\n        display: flex;\n        flex-direction: column\n    }\n\n    #footer-links-content,\n    #footer-links-brands {\n        display: block\n    }\n\n    #footer-links-brands-2,\n    #footer-links-brands-3 {\n        width: 100%\n    }\n\n    #footer-sub ul {\n        display: block\n    }\n\n    #footer-sub p {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        margin-bottom: 8px\n    }\n\n    #footer-sub-1 li {\n        margin-bottom: 16px\n    }\n\n    #footer-sub-1 li:last-child {\n        margin-bottom: 25px\n    }\n\n    #footer-links-brands {\n        padding-bottom: 24px;\n        padding-top: 0\n    }\n\n    #footer-links-brands-heading,\n    #footer-links-content-heading {\n        padding-top: 24px;\n        padding-bottom: 24px\n    }\n\n    #footer-links-content {\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    #footer-links-main li,\n    #footer-links-content li,\n    #footer-links-brands li {\n        padding-bottom: 8px\n    }\n\n    #footer-links-main li:nth-child(6),\n    #footer-links-content li:last-child,\n    #footer-links-brands li:last-child {\n        padding-bottom: 0\n    }\n\n    #footer-links-content-1 ul,\n    #footer-links-content-2 ul,\n    #footer-links-brands-1 ul,\n    #footer-links-brands-2 ul {\n        padding-bottom: 8px\n    }\n\n    #footer-links-main-1 h3,\n    #footer-links-main-2 h3,\n    #footer-links-main-3 h3,\n    #footer-links-main-4 h3,\n    #footer-links-content-heading,\n    #footer-links-brands-heading {\n        display: flex;\n        justify-content: space-between;\n        cursor: pointer\n    }\n\n\n    .ft-close-divider {\n        border-bottom: 1px solid #d1d5db\n    }\n\n    .ft-close-divider {\n        margin: 14px 24px\n    }\n\n    #footer-links-main-2 ul,\n    #footer-links-main-3 ul,\n    #footer-links-main-4 ul,\n    #footer-links-content {\n        display: none\n    }\n\n    #footer-social-wrapper {\n        display: none;\n        padding: 24px;\n        padding-top: 12px\n    }\n\n    #footer-social-wrapper h3 {\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 28px;\n        color: #171717;\n        margin-bottom: 18px\n    }\n\n    #footer-social-mobile a {\n        color: #334155 !important;\n        margin-right: 10px;\n        font-size: 17px\n    }\n\n    .ft-close-divider-2 {\n        border-bottom: 1px solid #334155;\n        margin-bottom: -24px;\n        padding-bottom: 12px\n    }\n\n    #footer-links-main-2 ul,\n    #footer-links-main-3 ul,\n    #footer-links-main-4 ul {\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    #footer-links-brands-heading.ft-close {\n        padding-bottom: 0\n    }\n\n    #footer-links-content {\n        padding-bottom: 24px\n    }\n\n    #footerlinks-main-4 {\n        border-bottom: 1px solid #334155\n    }\n}\n\n.hero-header {\n    font-family: 'ibm plex serif'\n}\n\n.pabloo-top-6-advantages {\n    margin-top: -3px !important\n}\n\n.pabloo-hero-tagline {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px !important\n}\n\n.hero-main-image {\n    margin-bottom: -520px !important\n}\n\n.pabloo-home-feature-grid {\n    padding-top: 410px !important\n}\n\n.pabloo-home-feature-grid-2 {\n    padding-top: 340px !important\n}\n\n.pabloo-top-6-advantages p {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.home-template-section-title {\n    font-family: 'ibm plex serif' !important;\n    font-weight: 700 !important;\n    font-size: 40px !important;\n    line-height: 48px !important\n}\n\n.home-section1-header {\n    font-family: 'ibm plex serif';\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px;\n    max-width: 800px;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.home-what-people-are-saying-title,\n.home-templates-title,\n.home-faq-title,\n.header-wordpress-tips-and-tricks {\n    font-family: 'ibm plex serif';\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.home-section1-desc {\n    font-weight: 400;\n    max-width: 900px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.home-section1-feature img {\n    align-self: flex-start\n}\n\n.home-section1-feature .sp-text-center {\n    text-align: left\n}\n\n.home-section1-feature .sp-css-description {\n    font-weight: 500\n}\n\n.home-section1-features pre {\n    display: none\n}\n\n.home-section1-features {\n    gap: 24px;\n    margin-bottom: 32px !important\n}\n\n.home-section1-features h3 {\n    font-weight: 700;\n    font-size: 20px !important;\n    line-height: 24px !important\n}\n\n.home-section1-features p {\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px\n}\n\n.home-section1-features {\n    margin-bottom: 0 !important\n}\n\n.home-section1-cta {\n    margin-top: 10px !important\n}\n\n@media(max-width:640px) {\n\n    .home-what-people-are-saying-title,\n    .home-templates-title,\n    .home-faq-title,\n    .header-wordpress-tips-and-tricks {\n        font-size: 22px !important;\n        line-height: 30px !important\n    }\n}\n\n.home-section-what-users-say .sp-section-shape .pabloo-shape-fill {\n    fill: #faf7f1\n}\n\n.home-section1-see-all a {\n    margin-left: 18px;\n    text-decoration: none !important;\n    padding-bottom: 3px;\n    color: #171717;\n    font-weight: 500;\n    border-bottom: 1px solid #171717\n}\n\n.four-nine {\n    font-weight: 500\n}\n\n.home-testimonials pre,\n.home-testimonials .sp-el-col pre {\n    display: none\n}\n\n.home-testimonials {\n    gap: 24px\n}\n\n.home-testimonials .sp-testimonial-wrapper img {\n    display: none\n}\n\n.home-testimonials p {\n    margin-bottom: 30px;\n    font-weight: 500\n}\n\n.home-testimonials .sp-el-col {\n    min-height: 462px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center\n}\n\n@media(max-width:640px) {\n    .testimonial-grid .testimonial {\n        box-shadow: none !important\n    }\n\n    .testimonial-grid .testimonial:nth-child(3),\n    .testimonial-grid .testimonial:nth-child(4),\n    .testimonial-grid .testimonial:nth-child(5),\n    .testimonial-grid .testimonial:nth-child(6),\n    .testimonial-grid .testimonial:nth-child(7),\n    .testimonial-grid .testimonial:nth-child(8),\n    .testimonial-grid .testimonial:nth-child(9),\n    .testimonial-grid .testimonial:nth-child(10),\n    .testimonial-grid .testimonial:nth-child(11),\n    .testimonial-grid .testimonial:nth-child(12),\n    .testimonial-grid .testimonial:nth-child(13),\n    .testimonial-grid .testimonial:nth-child(14),\n    .testimonial-grid .testimonial:nth-child(15),\n    .testimonial-grid .testimonial:nth-child(16),\n    .testimonial-grid .testimonial:nth-child(17) {\n        display: none\n    }\n}\n\n.home-section-top7 {\n    font-weight: 400\n}\n\n.home-section-top7 h2 {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.home-section-top7 h3 {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 36px\n}\n\n.home-top-7-row {\n    margin-bottom: 20px !important;\n    gap: 40px\n}\n\n@media(max-width:640px) {\n    .home-section-top7 h1 {\n        font-size: 22px !important;\n        line-height: 30px !important\n    }\n}\n\n.home-faq-desc,\n.home-tandt-desc {\n    font-weight: 400\n}\n\n.home-faq-desc a {\n    color: #374151 !important;\n    text-decoration: none !important;\n    border-bottom: 1px solid #374151\n}\n\n.faq__accordion .fa-angle-right,\n.faq__accordion .fa-angle-down {\n    line-height: 1 !important\n}\n\n.page-home-page .sp-posts-shortcode {\n    position: relative\n}\n\n@media(max-width:640px) {\n    .page-home-page .sp-posts-shortcode:after {\n        display: none\n    }\n}\n\n\n.global-design-header h1 {\n    padding-top: 66px;\n    padding-bottom: 3px;\n    font-family: 'ibm plex serif', serif !important;\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.global-design-header .sp-text-wrapper {\n    font-weight: 400\n}\n\n@media(max-width:640px) {\n    .global-design-header h1 {\n        font-weight: 700 !important;\n        font-size: 24px !important;\n        line-height: 32px !important\n    }\n\n    .global-design-header .sp-text-wrapper {\n        font-weight: 500 !important;\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n\n    .global-design-header .sp-text-wrapper p {\n        text-align: center !important\n    }\n}\n\n.page-home-page .sp-posts-block-wrapper .sp-custom-grid {\n    position: relative;\n    z-index: 20\n}\n\n.global-cta {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.global-cta-headline {\n    font-weight: 900\n}\n\n.global-cta-text {\n    font-weight: 500\n}\n\n.cta-headline {\n    font-weight: 900\n}\n\n.cta-desc {\n    font-weight: 500\n}\n\n#footer-cta .sp-section-shape {\n    position: relative\n}\n\n.footer-links-1 {\n    font-weight: 500\n}\n\n.footer-divider-header {\n    white-space: nowrap\n}\n\n.footer-divider {\n    width: 100%\n}\n\n.footer-terms-links a {\n    text-decoration: none;\n    font-weight: 500\n}\n\n.footer-am-branding h4 {\n    margin-bottom: 0\n}\n\n.home #sp-kzokb6 .sp-section-top .pabloo-shape-fill {\n    fill: #edf8fc\n}\n\n.home .pabloo-site-footer-wrapper #footer-cta,\n.page-id-22068 .pabloo-site-footer-wrapper #footer-cta {\n    position: relative;\n    top: -150px;\n    margin-bottom: -150px\n}\n\n.blog-cta-logged-in,\n.blog-cta {\n    position: relative\n}\n\n.blog-cta-form {\n    position: absolute !important;\n    bottom: 44px;\n    left: 32px;\n    width: 361px !important;\n    margin: 0 !important\n}\n\n.blog-cta-form .wpforms-field {\n    padding-bottom: 0 !important\n}\n\n.blog-cta-form .wpforms-field-medium {\n    max-width: 100% !important\n}\n\n.blog-cta-form .wpforms-submit {\n    max-width: 100% !important;\n    background: #fe4715 !important;\n    border-radius: 4px !important;\n    padding: 12px 10px !important;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #f9fafb !important;\n    width: 100% !important;\n    border: none !important\n}\n\n.blog-cta-logged-in p {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #374151;\n    width: 364px;\n    position: absolute;\n    bottom: 171px;\n    left: 32px\n}\n\n.blog-cta-logged-in a {\n    background: #fe4715 !important;\n    border-radius: 4px !important;\n    padding: 12px 117px !important;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #f9fafb !important;\n    position: absolute;\n    bottom: 89px;\n    left: 32px;\n    text-decoration: none !important\n}\n\n@media(max-width:640px) {\n\n    .blog-cta-logged-in,\n    .blog-cta {\n        display: none\n    }\n\n    .wp-post-image {\n        padding: 14px !important\n    }\n}\n\n.blog-newsletter-sidebar input,\n.blog-newsletter-sidebar button {\n    max-width: 100% !important;\n    width: 100% !important;\n    box-shadow: none !important\n}\n\n.blog-newsletter-sidebar input::-webkit-input-placeholder {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.blog-newsletter-sidebar input:-ms-input-placeholder {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.blog-newsletter-sidebar input::placeholder {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.blog-newsletter-sidebar .wpforms-submit {\n    background: #fe4715 !important;\n    color: #fff !important;\n    border-radius: 4px !important;\n    font-weight: 600 !important;\n    font-size: 20px !important;\n    line-height: 28px !important;\n    padding: 12px 32px !important\n}\n\n.sidebar-newsletter .wpforms-container {\n    margin: 0 auto !important\n}\n\n.pabloo-blog,\n.pabloo-below-blog {\n    gap: 20px\n}\n\n.pabloo-blog-main {\n    width: 100% !important\n}\n\n.pabloo-blog-sidebar,\n.pabloo-below-blog-sidebar {\n    width: 413px !important\n}\n\n.sidebar-seach {\n    padding: 24px !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important\n}\n\n.sidebar-seach .sp-searchform input::-webkit-input-placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.sidebar-seach .sp-searchform input:-ms-input-placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.sidebar-seach .sp-searchform input::placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n.sidebar-seach form {\n    width: 100% !important\n}\n\n.sidebar-seach input {\n    height: 48px !important;\n    border: 1px solid #e5e7eb !important;\n    border-right: none !important;\n    font-weight: 500 !important;\n    font-size: 16px !important\n}\n\n.sidebar-seach button {\n    height: 48px !important;\n    border: 1px solid #e5e7eb !important;\n    border-left: none !important\n}\n\n.sidebar-seach form>div {\n    padding: 0 !important\n}\n\n.sidebar-popular {\n    border-top: none !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important\n}\n\n.sidebar-popular h3 {\n    margin-bottom: 30px !important\n}\n\n.sidebar-newsletter input {\n    height: 48px !important;\n    border: 1px solid #e5e7eb !important;\n    font-weight: 500 !important;\n    background: #f9fafb !important;\n    color: #6b7280 !important;\n    font-weight: 500 !important;\n    font-size: 16px !important\n}\n\n.sidebar-newsletter .sp-html .mb-2 {\n    margin-bottom: 16px !important\n}\n\n.sidebar-newsletter button {\n    height: 52px !important;\n    margin-top: 0 !important;\n    font-size: 20px !important;\n    font-weight: 600 !important\n}\n\n.sidebar-newsletter .sidebar-follow {\n    display: inline-flex !important;\n    width: 40% !important;\n    height: 30px !important\n}\n\n.sidebar-newsletter .sidebar-follow-links {\n    display: inline-flex !important;\n    width: 60% !important\n}\n\n.pabloo-blog-main-posts .sp-posts-block-title {\n    margin-top: 23px !important;\n    font-family: 'ibm plex serif', sans-serif !important\n}\n\n.pabloo-blog-main-posts .sp-posts-text {\n    font-weight: 400 !important\n}\n\n.pabloo-blog-main-posts .sp-posts-block-read-more {\n    font-weight: 500 !important\n}\n\n.sp-posts-block-pagination .page-numbers {\n    background: #f0f3f5;\n    width: 40px;\n    height: 40px;\n    border-radius: 100%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 4px;\n    margin-left: 4px;\n    color: #374151\n}\n\n.sp-posts-block-pagination .page-numbers.current {\n    background-color: #171717;\n    color: #fff\n}\n\n.sp-posts-block-pagination .next.page-numbers {\n    background: 0 0;\n    white-space: nowrap;\n    margin-left: 8px\n}\n\n.sp-posts-block-pagination .prev.page-numbers {\n    background: 0 0;\n    white-space: nowrap;\n    margin-right: 16px\n}\n\n.sp-postcontent p:empty {\n    display: none\n}\n\n@media(max-width:640px) {\n    .sp-posts-single-block {\n        margin-bottom: 0 !important;\n        padding: 24px !important\n    }\n\n    .pabloo-blog-main-posts .sp-posts-block-title {\n        margin: 0 !important;\n        font-weight: 700 !important;\n        font-size: 16px !important;\n        line-height: 24px !important;\n        text-align: left !important\n    }\n\n    .sp-posts-block-excerpt,\n    .sp-posts-block-read-more {\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px\n    }\n\n    .pabloo-blog-sidebar .sp-el-row,\n    .pabloo-blog-sidebar .sp-el-col,\n    .pabloo-blog-sidebar .sp-el-section,\n    .sidebar-blog-big-cta {\n        padding: 0 !important\n    }\n\n    .sidebar-seach {\n        display: none\n    }\n\n    .sidebar-popular,\n    .sidebar-newsletter {\n        border: none !important\n    }\n\n    .sidebar-popular-posts h3.sp-type-header {\n        text-align: left !important;\n        font-weight: 700 !important;\n        font-size: 22px !important;\n        line-height: 32px !important;\n        margin-bottom: 10px !important\n    }\n\n    .sidebar-newsletter h3.sp-type-header {\n        text-align: left !important;\n        font-weight: 700 !important;\n        font-size: 18px !important;\n        line-height: 28px !important;\n        margin-bottom: 10px !important\n    }\n\n    .sidebar-blog-big-cta,\n    .sidebar-popular-post {\n        margin-bottom: 60px !important\n    }\n\n    h1.sp-type-posttitle,\n    #b2xxuk.sp-type-posttitle {\n        text-align: left !important\n    }\n\n    .sp-postcontent h2,\n    .sp-postcontent h3,\n    .sp-postcontent h4,\n    .sp-postcontent h5,\n    .sp-postcontent h6 {\n        text-align: left !important\n    }\n\n    .sp-postcontent h2 {\n        font-size: 18px !important;\n        line-height: 28px !important\n    }\n\n    .sp-postcontent h3 {\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n\n    .sp-postcontent h4 {\n        font-size: 15px !important;\n        line-height: 23px !important\n    }\n}\n\n.blog-comments .fn a {\n    color: #334155 !important;\n    font-size: 18px !important\n}\n\n.blog-comments .comment-metadata a {\n    color: #374151 !important;\n    font-weight: 500;\n    font-size: 16px !important\n}\n\n.blog-comments .avatar {\n    width: 64px !important;\n    height: 64px !important;\n    margin-right: 35px !important\n}\n\n.blog-comments .comment-body {\n    margin-top: 105px !important;\n    border: 1px solid #e5e7eb !important\n}\n\n.blog-comments .comment-author {\n    margin-top: -112px !important\n}\n\n.blog-comments .comment-metadata {\n    margin-bottom: 56px !important\n}\n\n.blog-comments .comments-title {\n    margin-bottom: 15px\n}\n\n.blog-comments #respond {\n    margin-top: 36px !important\n}\n\n.blog-comments .reply a {\n    padding: 8px !important;\n    color: #4b5563 !important;\n    background: #e5e7eb !important;\n    font-size: 16px !important;\n    font-weight: 500 !important\n}\n\n.blog-comments .comment-respond {\n    background: #f3f4f6;\n    border-radius: 8px;\n    padding: 40px\n}\n\n.blog-comments #reply-title {\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    color: #334155;\n    margin-bottom: 12px !important\n}\n\n.blog-comments .commentpolicy,\n.blog-comments .logged-in-as {\n    font-weight: 500 !important;\n    font-size: 14px !important;\n    line-height: 18px !important;\n    color: #374151 !important;\n    max-width: 632px;\n    margin-bottom: 30px !important\n}\n\n.blog-comments input[type=text],\n.blog-comments textarea {\n    width: 100%\n}\n\n.blog-comments .comment-form-cookies-consent label {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #334155 !important\n}\n\n.blog-comments input[type=submit] {\n    border-radius: 4px !important;\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    padding: 12px 24px !important\n}\n\ninput[type=text],\ninput[type=password],\ninput[type=email],\ninput[type=url],\ninput[type=date],\ninput[type=month],\ninput[type=time],\ninput[type=datetime],\ninput[type=datetime-local],\ninput[type=week],\ninput[type=number],\ninput[type=search],\ninput[type=tel],\ninput[type=color],\nselect,\ntextarea {\n    font-family: inter, sans-serif !important;\n    border: 1px solid #e5e7eb !important;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, .1) !important;\n    border-radius: 4px !important;\n    font-weight: 400 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #374151 !important\n}\n\n.wp-blocks-headers {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    margin-bottom: 15px !important;\n    margin-top: 20px !important\n}\n\n.wp-blocks-description {\n    margin-bottom: 34px !important\n}\n\n.sp-block-list .sp-el-col {\n    background: #fff;\n    border: 1.5px solid #e2e8f0 !important;\n    border-radius: 7px !important;\n    min-height: 152px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-block: 10px\n}\n\n.sp-block-list .sp-el-col img {\n    width: 44px !important\n}\n\n.sp-block-list .wp-block-headline img {\n    width: 34px !important\n}\n\n.sp-block-list .sp-el-col p {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.pricing-14-days {\n    position: absolute;\n    margin-top: -100px !important\n}\n\n.pricing-info {\n    margin-top: -170px !important\n}\n\n.pricing-header {\n    max-width: 975px !important;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.pricing-what-people-are-saying-header {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.pricing-table__plan {\n    background-color: #fff\n}\n\n.help-question-icon {\n    margin-left: 8px\n}\n\n.storage-icon {\n    margin-right: 8px\n}\n\n.feature-header {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px\n}\n\n.features-2-col-lg,\n.features-2-col-sm,\n.features-3-col .sp-el-col {\n    border: 2px solid #efefef !important\n}\n\n.features-2-col-lg h3,\n.features-2-col-sm h3,\n.features-3-col .sp-el-col h3 {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    text-align: left\n}\n\n.features-2-col-lg .sp-css-description p,\n.features-2-col-sm .sp-css-description p,\n.features-3-col .sp-el-col .sp-css-description p {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px;\n    color: #353535;\n    margin-bottom: 0 !important\n}\n\n.features-2-col-sm,\n.features-2-col-lg {\n    padding: 40px !important\n}\n\n.features-3-col div.sp-col-empty {\n    border: none !important\n}\n\n.integrations-rows div.sp-col-empty {\n    border: none !important\n}\n\n.features-2-col-sm,\n.features-2-col-lg,\n.features-3-col .sp-el-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end\n}\n\n.features-3-col,\n.features-2-col {\n    gap: 20px\n}\n\n.features-2-col {\n    min-height: 442px !important\n}\n\n.features-2-col-lg .sp-text-wrapper {\n    max-width: 344px\n}\n\n.highlight-feature-1 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-1 .sp-feature-wrapper img {\n    margin-left: 40px\n}\n\n.highlight-feature-1 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-2 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-2 .sp-feature-wrapper img {\n    margin-left: 40px;\n    margin-bottom: -42px\n}\n\n.highlight-feature-2 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-3 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-3 .sp-feature-wrapper img {\n    margin-left: 0;\n    margin-right: -40px;\n    margin-top: -21px;\n    position: relative;\n    top: -33px\n}\n\n.highlight-feature-3 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-4 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-4 .sp-feature-wrapper img {\n    margin-left: 40px;\n    margin-right: -20px;\n    position: relative;\n    top: -129px\n}\n\n.highlight-feature-4 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-5 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-5 .sp-feature-wrapper img {\n    margin-left: 40px;\n    margin-bottom: -42px;\n    margin-right: -40px\n}\n\n.highlight-feature-5 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-6 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-6 .sp-feature-wrapper img {\n    margin-left: -46px;\n    top: -20px;\n    margin-right: -41px;\n    position: relative;\n    margin-bottom: -57px\n}\n\n.highlight-feature-6 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.highlight-feature-7 .sp-feature-wrapper>div {\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n    align-items: flex-start\n}\n\n.highlight-feature-7 .sp-feature-wrapper img {\n    position: relative;\n    top: -218px\n}\n\n.highlight-feature-7 .sp-feature-wrapper>div p {\n    text-align: left\n}\n\n.features-theme-builder-header {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    margin-top: 80px !important;\n    margin-bottom: 50px !important;\n    max-width: 549px;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.feature-header-integrations {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 40px !important;\n    line-height: 48px !important\n}\n\n.integrations-rows {\n    gap: 56px;\n    margin-bottom: 24px !important\n}\n\n.integrations-rows .sp-el-col {\n    border: 2px solid #e2e8f0;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 24px\n}\n\n.integrations-rows .sp-el-col p {\n    margin-top: 15px;\n    margin-bottom: 12px;\n    text-align: center\n}\n\n.features-nav a:hover {\n    color: #171717 !important\n}\n\n.features-nav li:last-child a {\n    color: #16a34a !important\n}\n\n.features-3-col img {\n    margin-top: 30px !important;\n    margin-bottom: 24px !important\n}\n\n.features-3-col p {\n    margin-bottom: 30px !important\n}\n\n@media(max-width:640px) {\n    .features-2-col {\n        min-height: auto !important\n    }\n\n    .features-nav .sp-nav-wrapper {\n        flex-direction: row;\n        flex-wrap: wrap;\n        gap: 20px;\n        justify-content: center\n    }\n\n    .features-3-col img {\n        max-width: 60px !important\n    }\n\n    .features-3-col p {\n        margin-bottom: 0 !important\n    }\n\n    .features-theme-builder-header {\n        margin-top: 20px !important;\n        margin-bottom: 20px !important\n    }\n\n    .features-2-col-lg.sp-el-col,\n    .features-2-col-sm.sp-el-col {\n        padding: 16px !important\n    }\n\n    .features-2-col,\n    .features-3-col {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 24px !important\n    }\n\n    .features-2-col.sp-el-row,\n    .features-3-col.sp-el-row {\n        margin-bottom: 16px !important\n    }\n\n    .features-2-col-sm .sp-feature-wrapper {\n        text-align: left !important\n    }\n\n    .features-2-col-lg .sp-type-header {\n        margin-top: 140px !important\n    }\n\n    .features-2-col-lg h3,\n    .features-2-col-sm h3 {\n        font-weight: 700 !important;\n        font-size: 20px !important;\n        line-height: 24px !important;\n        text-align: left !important\n    }\n\n    .features-2-col-lg p,\n    .features-2-col-sm p,\n    .features-3-col p {\n        font-weight: 500 !important;\n        font-size: 14px !important;\n        line-height: 24px !important\n    }\n\n    .features-3-col.sp-el-row {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .features-3-col .sp-feature-wrapper {\n        display: flex !important;\n        padding: 16px !important\n    }\n\n    .features-3-col h3 {\n        text-align: left !important;\n        font-weight: 700 !important;\n        font-size: 20px !important;\n        line-height: 24px !important\n    }\n\n    .features-3-col .sp-css-description {\n        font-weight: 500 !important;\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n\n    .integrations-rows {\n        justify-content: center !important;\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 30px !important;\n        align-items: center !important;\n        margin-bottom: 0 !important\n    }\n\n    .integrations-rows .sp-el-col {\n        max-width: 211px\n    }\n\n    .features-2-col-lg .sp-feature-wrapper img {\n        display: none !important\n    }\n\n    .feature-image-3-mobile img {\n        margin-right: -38px\n    }\n\n    .feature-image-4-mobile img {\n        margin-right: -38px;\n        margin-bottom: -61px\n    }\n}\n\n@media(max-width:1100px) {\n    .global-cta {\n        background-size: cover !important\n    }\n}\n\n@media(max-width:640px) {\n    .pabloo-hero-tagline p {\n        text-align: center !important;\n        font-size: 14px;\n        line-height: 22px\n    }\n\n    .hero-main-image {\n        margin-bottom: -83px !important\n    }\n\n    .pabloo-top-6-advantages {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        margin-top: -20px !important\n    }\n\n    .pabloo-top-6-advantages .sp-el-col {\n        width: 33.333% !important\n    }\n\n    .pabloo-top-6-advantages .sp-text-wrapper {\n        padding: 0 !important\n    }\n\n    .pabloo-top-6-advantages .sp-text-wrapper p {\n        text-align: center !important;\n        font-size: 12px !important;\n        line-height: 18px !important\n    }\n\n    .home-hero-button {\n        width: auto !important;\n        padding: 12px 50px !important;\n        margin-top: -10px !important;\n        margin-bottom: -60px !important\n    }\n\n    .home-hero-button strong {\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .home-trust-badges {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        margin-top: 60px !important;\n        margin-bottom: 40px !important\n    }\n\n    .home-hero-image {\n        margin-top: -10px !important\n    }\n\n    .home-hero-companies {\n        margin-top: -32px !important\n    }\n\n    .home-hero-companies .sp-text-wrapper p {\n        text-align: center !important;\n        font-size: 10px !important;\n        line-height: 10px !important\n    }\n\n    .home-section1-header {\n        font-weight: 700 !important;\n        font-size: 22px !important;\n        line-height: 30px !important;\n        margin-top: 20px !important\n    }\n\n    .home-section1-desc p,\n    .home-section1-desc {\n        font-weight: 400 !important;\n        font-size: 14px !important;\n        line-height: 18px !important;\n        text-align: center !important\n    }\n\n    .home-section1-desc {\n        margin-bottom: 0 !important\n    }\n\n    .home-section1-features .sp-el-col {\n        margin-bottom: 0 !important\n    }\n\n    .home-section1-features.sp-el-row {\n        margin-bottom: 0 !important;\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .home-section1-features .sp-feature-wrapper {\n        display: flex !important;\n        padding: 16px !important\n    }\n\n    .home-section1-features h3 {\n        text-align: left !important;\n        font-weight: 700 !important;\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n\n    .home-section1-features .sp-css-description,\n    .home-section1-features p {\n        font-weight: 400 !important;\n        font-size: 14px !important;\n        line-height: 18px !important\n    }\n\n    .home-templates-title {\n        font-size: 22px;\n        line-height: 30px\n    }\n\n    .home-templates-desc {\n        font-size: 14px !important;\n        line-height: 18px !important;\n        text-align: center !important\n    }\n\n    .home-section1-cta {\n        margin-top: -26px !important\n    }\n\n    .home-section1-cta .sp-text-wrapper {\n        text-align: center !important\n    }\n\n    .home-section1-cta .sp-text-wrapper a {\n        text-align: center !important;\n        display: inline-block !important;\n        margin-left: 0 !important\n    }\n\n    .home-testimonial-tagline {\n        display: flex !important\n    }\n\n    .home-testimonials .sp-el-col {\n        margin-bottom: 16px !important;\n        min-height: auto !important\n    }\n\n    .home-testimonials .sp-testimonial-comment {\n        font-weight: 500 !important;\n        font-size: 18px !important;\n        line-height: 28px !important;\n        margin-bottom: 8px !important;\n        padding-top: 0 !important\n    }\n\n    .home-testimonials small strong {\n        font-weight: 700 !important;\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n\n    #home-heart-header {\n        max-width: 700px !important;\n        font-size: 22px !important;\n        line-height: 30px !important\n    }\n\n    #home-heart-header img {\n        width: 25px !important\n    }\n\n    .home-heart-tagline p {\n        font-weight: 400 !important;\n        font-size: 14px !important;\n        line-height: 18px !important;\n        text-align: center !important\n    }\n\n    .home-top-7-row2,\n    .home-top-7-row4,\n    .home-top-7-row6 {\n        display: flex !important;\n        flex-direction: column-reverse !important\n    }\n\n    .home-top-7-row {\n        gap: 0 !important\n    }\n\n    .home-top-7-row h3 {\n        text-align: left !important\n    }\n\n    .home-section1-see-all {\n        margin-top: 10px !important\n    }\n\n    .home-section1-cta {\n        margin-bottom: 0 !important\n    }\n\n    .home-testimonials .sp-testimonial-wrapper {\n        padding-bottom: 0 !important\n    }\n\n    .global-cta-wrapper.sp-el-section,\n    .global-cta-wrapper .sp-el-row,\n    .global-cta-wrapper .sp-el-col {\n        padding: 0 !important;\n        margin-left: 0 !important;\n        margin-right: 0 !important\n    }\n\n}\n\n.testimonials-main-stats {\n    gap: 60px\n}\n\n.testimonials-page-3-col .sp-el-col {\n    background: #fff;\n    box-shadow: 0 0 2px rgba(0, 0, 0, .2), 0 2px 10px rgba(0, 0, 0, .1);\n    border-radius: 8px;\n    border: none !important;\n    font-weight: 400;\n    font-size: 12px !important;\n    line-height: 20px !important\n}\n\n.testimonials-page-3-col .sp-el-col strong {\n    font-weight: 600 !important\n}\n\n.testimonials-page-description {\n    max-width: 870px;\n    margin-bottom: 100px !important\n}\n\n.testimonials-page-3-col {\n    gap: 20px\n}\n\n.testimonial-badges {\n    margin-top: 30px !important\n}\n\n.testimonial-badges .sp-text-wrapper {\n    position: relative;\n    top: -46px;\n    left: -24px\n}\n\n.testimonials-global-cta-wrapper {\n    margin-top: 40px !important;\n    margin-bottom: 50px !important\n}\n\n@media(max-width:640px) {\n    .testimonials-page-description {\n        margin-bottom: 16px !important\n    }\n\n    .testimonials-main-stats {\n        display: flex !important;\n        gap: 12px !important\n    }\n\n    .testimonials-main-stats h2 {\n        font-size: 20px !important;\n        padding-bottom: 8 !important;\n        padding-bottom: 0 !important\n    }\n\n    .testimonials-main-stats .sp-text-wrapper p {\n        font-size: 12px !important;\n        text-align: center !important\n    }\n\n    .testimonial-badges {\n        margin-top: 0 !important\n    }\n\n    .testimonial-badges p {\n        text-align: center !important\n    }\n\n    .home-hero-button.testimonials-button {\n        margin-top: 16px !important\n    }\n\n    #sp-ov14bq .sp-button-wrapper {\n        margin-top: -33px !important;\n        margin-bottom: 15px !important\n    }\n\n    .testimonials-page-3-col {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 24px !important\n    }\n\n    .testimonial-page-3-col .sp-text-wrapper {\n        margin-bottom: 10px !important\n    }\n\n    .testimonial-page-3-col .sp-el-block {\n        padding-top: 0 !important\n    }\n\n    .testimonials-global-cta-wrapper {\n        margin-top: 20px !important;\n        margin-bottom: 30px !important\n    }\n\n    .testimonials-hero-button {\n        padding: 16px 32px !important\n    }\n\n    .testimonials-hero-button strong {\n        font-size: 16px !important;\n        line-height: 24px !important\n    }\n}\n\n.lite-upgrade-page-description {\n    max-width: 850px;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.lite-upgrade-global-feature-grid-wrapper .home-section1-header,\n.lite-upgrade-global-feature-grid-wrapper .home-section1-desc,\n.lite-upgrade-global-feature-grid-wrapper .sp-spacer,\n.lite-upgrade-global-feature-grid-wrapper .home-section1-see-all:after {\n    display: none\n}\n\n.lite-pro-comparison-section h1 {\n    font-family: 'ibm plex serif';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.wordpress-block-sp-nav li:last-child a {\n    color: #16a34a !important\n}\n\n@media(max-width:640px) {\n    .sp-block-list {\n        display: flex !important;\n        flex-wrap: wrap !important;\n        gap: 10px !important\n    }\n\n    .sp-block-list .sp-el-col {\n        width: 46% !important\n    }\n\n    .sp-block-list .sp-el-col p {\n        text-align: center\n    }\n}\n\n.section-contact h2 {\n    font-family: 'ibm plex serif';\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 32px\n}\n\n.contact-us-adv-btn,\n.contact-us-basic-btn {\n    padding: 15px 20px !important;\n    width: 289px !important\n}\n\n.contact-us-basic-btn {\n    border-width: 2px !important\n}\n\n.section-contact {\n    gap: 17px\n}\n\n@media(max-width:640px) {\n    .section-contact {\n        display: flex;\n        flex-direction: column;\n        gap: 24px\n    }\n\n    .section-contact .sp-el-col {\n        padding: 12px !important\n    }\n\n    .section-contact .sp-type-header {\n        font-weight: 700 !important;\n        font-size: 18px !important;\n        line-height: 28px !important\n    }\n\n    .section-contact .sp-text-wrapper p {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 24px;\n        text-align: center\n    }\n}\n\n#theme-pabloo-body {\n    background-color: #fff\n}\n\n.pabloo-theme-header {\n    position: relative;\n    background-color: #fff4e4;\n    width: 100%;\n    max-width: 100%;\n    padding: 20px\n}\n\n.pabloo-theme-header-inner {\n    max-width: 900px;\n    margin: 0 auto;\n    text-align: center\n}\n\n.pabloo-theme-header-inner h1 {\n    font-size: 40px;\n    text-align: center;\n    margin: 0;\n    padding-top: 54px;\n    padding-bottom: 3px;\n    color: #171717;\n    font-weight: 700;\n    font-style: normal\n}\n\n.pabloo-theme-header-inner p {\n    font-size: 18px;\n    margin: 0;\n    font-weight: 500;\n    padding: 10px;\n    padding-bottom: 70px;\n    color: #374151\n}\n\n@media(max-width:640px) {\n    .pabloo-theme-header-inner h1 {\n        font-weight: 700 !important;\n        font-size: 24px !important;\n        line-height: 32px !important\n    }\n\n    .pabloo-theme-header-inner p {\n        font-weight: 500 !important;\n        font-size: 16px !important;\n        line-height: 24px !important;\n        padding: 10px\n    }\n}\n\n#hkb .hkb-fullwcontainer {\n    width: 100% !important\n}\n\n#docs-home {\n    background: #fff;\n    max-width: 1280px;\n    margin: 0 auto;\n    margin-top: 60px;\n    padding-bottom: 80px\n}\n\n#docs-home__categories {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px\n}\n\n.docs-home__category {\n    border: 2px solid #e5e7eb;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 413px;\n    text-align: center;\n    padding: 32px\n}\n\n.docs-home__category h2 {\n    font-family: inter, sans-serif !important;\n    font-weight: 700;\n    font-size: 19px;\n    line-height: 150%;\n    color: #171717;\n    margin-bottom: 16px\n}\n\n.docs-home__category a {\n    box-sizing: border-box;\n    font-weight: 700;\n    font-size: 15px;\n    line-height: 100%;\n    color: #353535;\n    background: #fff;\n    border: 1px solid #16a34a;\n    border-radius: 4px;\n    padding: 12px 20px 13px;\n    display: inline-block\n}\n\n.docs-home__category a:hover {\n    color: #16a34a\n}\n\n#hkb .hkb-searchbox-wrapper[data-hkb-header-type=solid] {\n    background: #fff !important\n}\n\n.hkb-searchbox__title {\n    display: none\n}\n\n#hkb .hkb-container {\n    max-width: 1320px !important;\n    padding: 0 20px !important\n}\n\n#hkb .hkb-searchbox {\n    max-width: 1280px !important\n}\n\n#hkb .hkb-searchbox .hkb-site-search__field {\n    max-width: 1280px !important;\n    margin: 0 !important;\n    padding: 24px 64px !important;\n    box-shadow: none !important\n}\n\n#hkb .hkb-site-search .hkb-site-search__icon {\n    position: relative;\n    left: 14px;\n    height: 20px;\n    width: 20px;\n    top: 50%;\n    margin-top: -10px;\n    fill: #6b7280\n}\n\n#hkb .hkb-site-search .hkb-site-search__icon path {\n    fill: #fff !important\n}\n\n#hkb .hkb-searchbox .hkb-site-search__field::-webkit-input-placeholder {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    color: #6b7280\n}\n\n#hkb .hkb-searchbox .hkb-site-search__field:-ms-input-placeholder {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    color: #6b7280\n}\n\n#hkb .hkb-searchbox .hkb-site-search__field::placeholder {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    color: #6b7280\n}\n\n#hkb .hkb-searchbox-wrapper {\n    padding: 40px 0 !important\n}\n\n#docs-home__search .hkb-container {\n    padding: 0 !important\n}\n\n#docs-home__gettingstarted {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    position: relative\n}\n\n#docs-home__gettingstarted .widget-title {\n    font-weight: 700;\n    font-size: 28px;\n    line-height: 36px;\n    color: #334155;\n    padding: 26px 40px;\n    border-bottom: 1px solid #e5e7eb;\n    margin-bottom: 0 !important\n}\n\n#docs-home__gettingstarted li {\n    position: relative;\n    padding: 0 0 0 30px;\n    background: 0 0;\n    list-style: none;\n    text-indent: 0;\n    margin: 0 0 20px !important;\n    line-height: unset;\n    width: 50%;\n    border-bottom: none !important\n}\n\n#docs-home__gettingstarted ul {\n    padding: 46px 40px 14px;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%\n}\n\n#docs-home__gettingstarted li a {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 28px;\n    text-align: center;\n    color: #334155\n}\n\n.docs-submit-a-ticket {\n    background: #16a34a;\n    border-radius: 40px;\n    padding: 9px 16px;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: #f9fafb;\n    display: inline-block;\n    position: absolute;\n    right: 40px;\n    top: 24px\n}\n\n.docs-submit-a-ticket:hover {\n    color: #f9fafb\n}\n\n\n@media(max-width:640px) {\n    #docs-home {\n        margin-top: 46px\n    }\n\n    #docs-home__categories {\n        margin-left: 25px;\n        margin-right: 25px\n    }\n\n    .docs-home__category {\n        margin-bottom: 0\n    }\n\n    #docs-home__search {\n        margin-left: 25px;\n        margin-right: 25px\n    }\n\n    #hkb .hkb-searchbox .hkb-site-search__field::-webkit-input-placeholder {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 20px;\n        color: #6b7280\n    }\n\n    #hkb .hkb-searchbox .hkb-site-search__field:-ms-input-placeholder {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 20px;\n        color: #6b7280\n    }\n\n    #hkb .hkb-searchbox .hkb-site-search__field::placeholder {\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 20px;\n        color: #6b7280\n    }\n\n    #hkb .hkb-searchbox .hkb-site-search__field {\n        padding: 12px 40px !important\n    }\n\n    .hkb-site-search:after {\n        top: 9px;\n        left: 6px;\n        position: absolute\n    }\n\n    #docs-home__gettingstarted {\n        margin-left: 25px;\n        margin-right: 25px\n    }\n\n    #docs-home__gettingstarted .widget-title {\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 32px;\n        padding: 20px\n    }\n\n    #docs-home__gettingstarted ul {\n        padding: 25px;\n        display: block;\n        width: 100%\n    }\n\n    #docs-home__gettingstarted li {\n        width: 100%\n    }\n\n    #docs-home__gettingstarted li a {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 18px\n    }\n\n    #docs-home__gettingstarted {\n        display: flex;\n        flex-direction: column\n    }\n\n    .docs-submit-a-ticket {\n        position: relative;\n        display: inline-block;\n        right: initial;\n        top: initial;\n        text-align: center\n    }\n}\n\n@media screen and (min-width:770px) {\n\n    #hkb .hkb-mainpage.hkb-mainpage--sidebarleft .hkb-mainpage__sidebar,\n    #hkb .hkb-mainpage.hkb-mainpage--sidebarright .hkb-mainpage__sidebar {\n        width: 32% !important\n    }\n}\n\n@media screen and (min-width:770px) {\n    #hkb .hkb-mainpage.hkb-mainpage--sidebarleft .hkb-mainpage__sidebar {\n        margin-right: 65px !important\n    }\n}\n\n.hkb-mainpage__main {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 45px\n}\n\n.hkb-categoryheader__icon,\n.hkb-categoryheader__description,\n.hkb-articlepreview__excerpt,\n.hkb_widget_categories .widget-title {\n    display: none !important\n}\n\n.hkb-mainpage__sidebar .widget {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px !important;\n    padding: 40px !important;\n    padding-bottom: 20px !important;\n    margin-bottom: 20px !important;\n    background: #fff !important\n}\n\n.hkb_widget_categories {\n    font-weight: 700;\n    font-size: 19px;\n    line-height: 150%;\n    color: #2a3851\n}\n\n.hkb_widget_categories li,\n.hkb_widget_articles li {\n    border-bottom: 1px solid #f1f1f6;\n    padding-bottom: 12px !important\n}\n\n.hkb_widget_categories li:last-of-type,\n.hkb_widget_articles li:last-of-type {\n    border-bottom: none\n}\n\n.hkb_widget_categories .current-cat {\n    color: #fe4715\n}\n\n.hkb_widget_articles .widget-title {\n    font-weight: 700;\n    font-size: 19px;\n    line-height: 150%;\n    color: #171717;\n    margin-bottom: 30px !important\n}\n\n.hkb_widget_articles a {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n    color: #2a3851 !important\n}\n\n.hkb_widget_articles li {\n    margin: 0 0 12px !important;\n    padding-left: 30px !important\n}\n\n.hkb-categoryheader__title {\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    color: #171717\n}\n\n#hkb .hkb-categoryheader {\n    border-bottom: none !important;\n    margin-bottom: 6px !important\n}\n\n#hkb .hkb-articlepreview {\n    padding: 10px 0 !important;\n    border-bottom: none !important\n}\n\n.hkb-articlepreview__title a {\n    position: relative;\n    font-weight: 500 !important;\n    font-size: 18px;\n    line-height: 160%;\n    color: #2a3851 !important;\n    padding-left: 35px !important\n}\n\n.hkb_widget_toc {\n    color: #2a3851 !important\n}\n\n#hkb .hkb_widget_toc ol li.active>a {\n    background: #fe4715 !important\n}\n\n.hkb-article {\n    color: #2a3851 !important;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 160%\n}\n\nh1.hkb-article__title,\n.hkb-article h1,\n.hkb-article h2,\n.hkb-article h3 {\n    color: #171717 !important\n}\n\nh1.hkb-article__title {\n    margin-bottom: 32px !important;\n    font-weight: 700 !important;\n    font-size: 32px !important;\n    line-height: 40px !important\n}\n\n#docs-sidebar__search .hkb-container {\n    padding: 0 !important\n}\n\n#docs-sidebar__search #hkb .hkb-searchbox .hkb-site-search__field {\n    padding: 12px 40px !important;\n    background-color: #f9fafb;\n    border: 1px solid #e5e7eb !important;\n    border-radius: 4px !important\n}\n\n#docs-sidebar__search .hkb-searchbox-wrapper {\n    padding: 0 !important;\n    padding-bottom: 20px !important\n}\n\n#docs-sidebar__search ::-webkit-input-placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n#docs-sidebar__search :-ms-input-placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\n#docs-sidebar__search ::placeholder {\n    font-weight: 700 !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n    color: #6b7280 !important\n}\n\ni.solution {\n    display: block;\n    width: fit-content;\n    background-color: #15955f;\n    color: #fff;\n    padding: 5px 10px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    border-radius: 5px\n}\n\ni.problem {\n    display: block;\n    width: fit-content;\n    background-color: #d63638;\n    color: #fff;\n    padding: 5px 10px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    border-radius: 5px\n}\n\n@media(max-width:640px) {\n    .hkb-mainpage__main {\n        border: none !important;\n        padding: 0 !important\n    }\n\n    h1.hkb-article__title,\n    .hkb-article h1,\n    .hkb-article h2,\n    .hkb-article h3 {\n        text-align: left !important\n    }\n\n    .hkb-article h2,\n    .hkb-article h3 {\n        font-size: 18px !important\n    }\n\n    h1.hkb-article__title {\n        margin-bottom: 24px !important;\n        font-weight: 700 !important;\n        font-size: 20px !important;\n        line-height: 30px !important\n    }\n\n    .hkb-article {\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .hkb-mainpage__sidebar .widget {\n        border: none !important;\n        padding: 0 !important\n    }\n\n    .hkb_widget_toc {\n        display: none\n    }\n\n    .hkb-categoryheader__title {\n        font-weight: 700 !important;\n        font-size: 19px !important;\n        line-height: 150% !important\n    }\n\n    .hkb-articlepreview__title {\n        text-align: left !important;\n        font-weight: 500 !important;\n        font-size: 14px !important;\n        line-height: 18px !important\n    }\n\n    .hkb_widget_articles .widget-title {\n        text-align: left !important\n    }\n\n    #hkb .hkb-mainpage-wrapper {\n        padding: 3em 0 2em !important\n    }\n}\n\n#docs-optin {\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 32px\n}\n\n#docs-optin h3 {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n    color: #171717;\n    margin-bottom: 32px !important\n}\n\n#docs-optin input {\n    padding: 12px;\n    background: #f9fafb;\n    border: 1px solid #e5e7eb !important;\n    border-radius: 4px !important;\n    box-shadow: none !important;\n    margin-bottom: 16px\n}\n\n#docs-optin button {\n    background: #fe4715;\n    border-radius: 4px !important;\n    padding: 12px 40px !important;\n    color: #fff;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 28px\n}\n\n.sidebar-follow {\n    display: flex;\n    color: #334155;\n    margin-top: 40px !important\n}\n\n@media(max-width:640px) {\n    #docs-optin {\n        border: none;\n        padding: 0\n    }\n\n    #docs-optin.sp-el-col,\n    #docs-optin .sp-el-block {\n        padding: 0 !important\n    }\n\n    .sidebar-follow {\n        margin-top: 20px !important\n    }\n\n    #docs-optin h3 {\n        text-align: left !important;\n        margin-bottom: 16px !important;\n        padding: 0 !important\n    }\n}\n\n.home-template-switcher {\n    margin-top: 10px;\n    margin-bottom: 37px;\n    display: flex\n}\n\n.home-template-switcher-col-1 {\n    min-width: 300px;\n    display: flex;\n    align-items: center\n}\n\n.home-template-switcher-col-1 ul {\n    list-style: none;\n    padding: 0;\n    margin: 0\n}\n\n.home-template-switcher-col-1 ul a {\n    font-family: 'ibm plex serif';\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 32px;\n    color: #74a3b8;\n    margin-bottom: 24px;\n    display: inline-block\n}\n\n.home-template-switcher-col-1 ul a.active {\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 32px;\n    color: #171717\n}\n\n@media(max-width:640px) {\n    .home-template-switcher {\n        flex-direction: column\n    }\n\n    .home-template-switcher-col-1 {\n        display: none\n    }\n}\n\n.page-functionality-list ul li {\n    font-family: 'ibm plex serif'\n}\n\n.pabloo-pages-hero-tagline {\n    font-weight: 600;\n    text-align: center;\n    font-style: normal;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.pabloo-pages-hero-bottom-hearder {\n    font-weight: 400;\n    text-align: center;\n    font-style: normal;\n    margin-left: auto !important;\n    margin-right: auto !important\n}\n\n.theme-page-main-image {\n    margin-bottom: -430px !important\n}\n\n.theme-page-main-image-2 {\n    margin-bottom: -290px !important\n}\n\n.pages-image-box-feature img {\n    align-self: flex-start;\n    margin-bottom: 24px\n}\n\n.pages-image-box-feature p {\n    font-family: inter, sans-serif !important;\n    font-weight: 400;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 26px\n}\n\n.pages-image-box-feature p a,\n.pages-template-text-description p a {\n    text-decoration: none;\n    color: #353535 !important\n}\n\n.pages-image-box-feature {\n    margin-bottom: 0 !important\n}\n\n.pages-image-box-feature .sp-text-center {\n    text-align: left\n}\n\n.pages-image-box-feature h3 {\n    font-family: manrope, sans-serif !important;\n    text-align: left;\n    font-weight: 700;\n    font-size: 20px !important;\n    line-height: 24px !important;\n    margin-bottom: 12px\n}\n\n.pages-image-box-feature .sp-css-description {\n    font-weight: 400\n}\n\n.theme-pages-feature-list li {\n    font-family: 'ibm plex serif';\n    line-height: 28px\n}\n\n.theme-pages-feature-list-2 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-3 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-4 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-5 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-6 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-7 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-8 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-9 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-10 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-11 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-12 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-13 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-14 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-15 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-16 li {\n    font-family: 'ibm plex serif';\n    line-height: 32px\n}\n\n.theme-pages-feature-list-action-button {\n    font-family: inter, sans-serif !important;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700 !important;\n    line-height: 24px;\n    background: #16a34a;\n    color: #fff;\n    display: inline-flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 8px\n}\n\n.theme-pages-feature-grid {\n    padding-top: 410px !important\n}\n\n.theme-page-testimonials .testimonial-grid {\n    max-height: 600px !important\n}\n\n.theme-page-testimonials .testimonial-grid .testimonial {\n    width: 30% !important;\n    max-width: 30% !important\n}\n\n.theme-page-heart-tagline p {\n    font-family: inter, sans-serif !important;\n    font-weight: 400 !important;\n    font-size: 18px;\n    line-height: 26px !important;\n    text-align: center !important;\n    width: 588px;\n    text-align: center\n}\n\n\n@media(max-width:1000px) {\n\n    .theme-pages-feature-list-3 li,\n    .theme-pages-feature-list-4 li,\n    .theme-pages-feature-list-5 li,\n    .theme-pages-feature-list-6 li,\n    .theme-pages-feature-list-7 li,\n    .theme-pages-feature-list-8 li,\n    .theme-pages-feature-list-9 li,\n    .theme-pages-feature-list-10 li,\n    .theme-pages-feature-list-11 li,\n    .theme-pages-feature-list-12 li,\n    .theme-pages-feature-list-13 li,\n    .theme-pages-feature-list-14 li,\n    .theme-pages-feature-list-15 li,\n    .theme-pages-feature-list-16 li {\n        font-size: 16px !important;\n        padding-bottom: 5px !important;\n        margin-top: 5px !important\n    }\n\n    .theme-pages-feature-list-3,\n    .theme-pages-feature-list-4,\n    .theme-pages-feature-list-5,\n    .theme-pages-feature-list-6,\n    .theme-pages-feature-list-7,\n    .theme-pages-feature-list-8,\n    .theme-pages-feature-list-9,\n    .theme-pages-feature-list-10,\n    .theme-pages-feature-list-11,\n    .theme-pages-feature-list-12,\n    .theme-pages-feature-list-13,\n    .theme-pages-feature-list-14,\n    .theme-pages-feature-list-15,\n    .theme-pages-feature-list-16 {\n        margin-top: 5px !important\n    }\n}\n\n@media(max-width:640px) {\n    .theme-pages-feature-images img {\n        height: auto !important;\n        width: max-content !important\n    }\n\n    .theme-page-main-image img {\n        height: auto !important;\n        width: max-content !important\n    }\n\n    .theme-pages-feature-grid,\n    #sp-qashqp,\n    #sp-jfish0,\n    #sp-q091f5,\n    #sp-vd4wrb,\n    #sp-ryaisf,\n    #sp-scazoy,\n    #sp-li3zfm,\n    #sp-g2t3cx,\n    #sp-jzpbk6 {\n        padding-top: 300px !important\n    }\n\n    #sp-qlxt13,\n    #sp-qh7qtr {\n        padding-top: 250px !important\n    }\n\n    .theme-page-main-image-2 img {\n        margin-top: -60px !important;\n        height: auto !important;\n        width: max-content !important\n    }\n\n    #sp-nz9mup {\n        margin-bottom: 200px !important\n    }\n\n    .theme-pages-feature-list {\n        margin-top: 0 !important\n    }\n\n    .theme-page-testimonials .testimonial-grid {\n        max-height: fit-content !important\n    }\n\n    .pages-image-box-feature h3 {\n        font-family: manrope, sans-serif !important;\n        text-align: left;\n        font-weight: 700;\n        font-size: 18px !important;\n        margin-bottom: 12px\n    }\n\n    .theme-page-heart-tagline p {\n        font-family: inter, sans-serif !important;\n        font-weight: 400 !important;\n        font-size: 14px;\n        line-height: 26px !important;\n        text-align: center !important;\n        text-align: center\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
